/**
 * @see https://webpack.js.org/guides/code-splitting/
 * @see https://webpack.js.org/guides/lazy-loading/
 */

////////////////////////////////////////////////////////////////////////////////
// UTILITY FUNCTIONS - Some need to load right away some can lazy loaded////////
////////////////////////////////////////////////////////////////////////////////

import { readCookie, setCookie, getCookie, createCookie, eraseCookie, deleteCookie } from './Utility/CookieManager.js';
import { rcmg_api_first_error, rcmg_api_call, mc_embedded_subscribe, reload_when_verticals_done_delete, clear_token_cookies, token_cookies_exist } from './RCMG_V2/RcmgCommon.js';
// import { checkIfGovAccount } from './Utility/IpInfo.js';
const StoryStreamSponsored = () => import(/* webpackChunkName: "StoryStreamSponsored" */'./StoryStreams/StoryStreamSponsored.js');
const MenuTriggers = () => import(/* webpackChunkName: "MenuTriggers" */'./Utility/MenuTriggers.js');
const RecentScrollerSlider = () => import(/* webpackChunkName: "RecentScrollerSlider" */'./Utility/RecentScrollerSlider.js');
const SocialTools = () => import(/* webpackChunkName: "SocialTools" */ "./Utility/SocialTools.js");
const MastHeadScroller = () => import(/* webpackChunkName: "MastHeadScroller" */ "./Utility/MastHeadScroller.js");
const HomepageLayoutSwitcher = () => import(/* webpackChunkName: "HomepageLayoutSwitcher" */ "./Utility/HomepageLayoutSwitcher.js");
const AdblockModalEventTriggers = () => import(/* webpackChunkName: "AdblockModalEventTriggers" */ "./Utility/AdblockModalEventTriggers.js");
const StoryStreamsHover = () => import(/* webpackChunkName: "StoryStreamsHover" */ "./StoryStreams/StoryStreamsHover.js");
const LazyInitBackgroundImages = () => import(/* webpackChunkName: "LazyInitBackgroundImages" */ "./Utility/LazyInitBackgroundImages.js");

////////////////////////////////////////////////////////////////////////////////
// CORE FUNCTIONALITY IMPORT ///////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

import { getSiteInfo, getSiteConfigs, setGlobalSiteConfigs, getLazySizesConfig } from './SiteConfigs.js';
import { setGlobalAdsConfigs, addGPTTag, addMoatTag } from './AdsConfig.js';
import load_admiral from './Admiral.js';
import rc_meta from './RCMeta.js'; // Replacing rc-meta-v2.js
rc_meta();

////////////////////////////////////////////////////////////////////////////////
// ADS MODULES /////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

const AdsenseAds = () => import(/* webpackChunkName: "AdsenseAds" */ "./Ads/AdsenseAds.js");
const HomepageDistroscale = () => import(/* webpackChunkName: "HomepageDistroscale" */ "./Ads/HomepageDistroscale.js");
const HomepageJwPlayer = () => import(/* webpackChunkName: "HomepageJwPlayer" */ "./Ads/HomepageJwPlayer.js");
const MgidScienceArticle = () => import(/* webpackChunkName: "MgidScienceArticle" */ "./Ads/MGID/MgidScienceArticle.js");
const FarkWidget = () => import(/* webpackChunkName: "FarkWidget" */ "./Ads/FarkWidget.js");
const InfinityAds = () => import(/* webpackChunkName: "InfinityAds" */ "./Ads/InfinityAds.js");
const Insticator = () => import(/* webpackChunkName: "Insticator" */ "./Ads/Insticator.js");
const MgidUnits = () => import(/* webpackChunkName: "MgidUnits" */ "./Ads/MGID/MgidUnits.js");
const SpotRightRail = () => import(/* webpackChunkName: "SpotRightRail" */ "./Ads/SpotRightRail.js");
const LeaderboardScroll = () => import(/* webpackChunkName: "LeaderboardScroll" */ "./Ads/LeaderboardScroll.js");
const GotChosen = () => import(/* webpackChunkName: "GotChosen" */ "./Ads/GotChosen.js");

window.createCookie = createCookie;
window.readCookie = readCookie;
window.eraseCookie = eraseCookie;
window.setCookie = setCookie;
window.getCookie = getCookie;
window.deleteCookie = deleteCookie;

window.token_cookies_exist = token_cookies_exist;
window.clear_token_cookies = clear_token_cookies;
window.reload_when_verticals_done_delete = reload_when_verticals_done_delete;
window.rcmg_api_call = rcmg_api_call;
window.mc_embedded_subscribe = mc_embedded_subscribe;
window.rcmg_api_first_error = rcmg_api_first_error;

import Utils from './Utility/Utility.js';
window.Utils = Utils;
import WarningWidget from './Utility/WarningWidget.js';
window.warning_widget = WarningWidget;

window.rcp_page_refresh_interval = ''; //DEFINING GLOBAL REFRESH INTERVAL SET IN rcp.js
window.dateMenuVisible = false;
window.allow_ad_render = false; // We want to wait until publir prebid is initialized fully
window.lazy_ad_list = []; // populated as scrolling down page
window.notif_banner_enabled = false; // ?
window.fire_gdpr_consent = true; // simple enable/disable flag
window.story_stream_related_tags_html = ''; // Used for story streams related topics
window.network_ads_loaded = false;

// EVOLOK //////////////////////////////////////////////////////////////////////

window.evolok_init_called = false;
window.evolok_init_finished = false;
window.evolok_block_ads = false;
window.evolok_do_ads = false;

// WIDGETS /////////////////////////////////////////////////////////////////////

window.$w_ss = []; // Holds multiple story streams
window.rcp_avg_w_total = 0;
window.rcp_avg_w_data = [];

// SOCIAL //////////////////////////////////////////////////////////////////////

window.fbShares = 0;
window.linkedCount = 0;
window.sharePosition = 0;
window.share_urls = [];

window.fbDone = false;
window.linDone = false;

////////////////////////////////////////////////////////////////////////////////
// BROWSER / OS DETECTION //////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

// Adds ability to detect browser
navigator.browserInfo = (function(){

    var ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {'browser': 'IE', 'version': (tem[1] || '')};
    }

    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null){
            var temp = tem.slice(1);
            return { 'browser': temp[0].replace('OPR', 'Opera'), 'version': temp[1] };
        }
    }

    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem = ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return { 'browser': M[0], 'version': M[1] };
})();

// Adds ability to detect OS
navigator.osInfo = (function(){
    var ua = navigator.userAgent;
    var av = navigator.appVersion;
    var os = 'unknown';
    var clientStrings = [
        {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
        {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
        {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
        {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
        {s:'Windows Vista', r:/Windows NT 6.0/},
        {s:'Windows Server 2003', r:/Windows NT 5.2/},
        {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
        {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
        {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
        {s:'Windows 98', r:/(Windows 98|Win98)/},
        {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
        {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s:'Windows CE', r:/Windows CE/},
        {s:'Windows 3.11', r:/Win16/},
        {s:'Android', r:/Android/},
        {s:'Open BSD', r:/OpenBSD/},
        {s:'Sun OS', r:/SunOS/},
        {s:'Linux', r:/(Linux|X11)/},
        {s:'iOS', r:/(iPhone|iPad|iPod)/},
        {s:'Mac OS X', r:/Mac OS X/},
        {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s:'QNX', r:/QNX/},
        {s:'UNIX', r:/UNIX/},
        {s:'BeOS', r:/BeOS/},
        {s:'OS/2', r:/OS\/2/},
        {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(ua)) {
            os = cs.s;
            break;
        }
    }

    var osVersion = 'unknown';

    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
    }

    switch (os) {
        case 'Mac OS X':
            
            osVersion = /Mac OS X ([0-9]+[0-9]+[\.\_\d]+)/.exec(ua)[1];

            if(osVersion == null) {
                osVersion = 'unknown';
            }
            break;

        case 'Android':
            osVersion = /Android ([\.\_\d]+)/.exec(ua)[1];
            if(osVersion == null) {
                osVersion = 'unknown';
            }
            break;

        case 'iOS':
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(av);
            if(osVersion == null) {
                osVersion = 'unknown';
            } else {
                osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            }
            break;
    }

    return { 'os': os, 'os_version': osVersion };
})();

window.mobileAndTabletcheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

window.send_ga_event = function(data)
{
    // REQUIRED INPUT:
    /*
  {
    'ge_action' : 'List View',
    'ge_category' : 'Homepage: Grid/List',
    'ge_label' : 'Click'
  }
  OPTIONAL INPUT:
  {
    'ge_noninteraction' : false
  }
  */

    if(typeof data['ge_noninteraction'] === 'undefined') {
        data['ge_noninteraction'] = true; // By default events are registered as noninteraction events, and leave bounce rate alone.
    }
    // Right now value is just always 0

    //Wrap event tracking call to prevent premature termination of this function.
    try{
        _gaq.push(['_trackEvent', data['ge_category'], data['ge_action'], data['ge_label'], 0, data['ge_noninteraction']]);
        // console.log('trackevent: '+data['ge_category']+' '+data['ge_action']+' '+data['ge_label']+' '+data['ge_noninteraction']);
    } catch(err) {}
}

window.iOSSafari = function(userAgent)
{
    return /iP(ad|od|hone)/i.test(userAgent) && /WebKit/i.test(userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(userAgent));
}

window.display_ios_modal = function(message , css_class){

    html = '<div class="pwa-underlay-notification '+ css_class +'">' +
        '<span class="btn-close">X</span>' +
        '<div class="pwa-wrapper">' +
        '   <a href="#" class="pwa-btn"> '+ message +'</a>' +
        '</div>'+
        '</div>';

    $('body').append(html);

    $(document).on('click', '.pwa-underlay-notification span.btn-close', function(e){
        $('.pwa-underlay-notification').hide().remove();
    });

    var data = {
        'ge_action' : 'Prompt',
        'ge_category' : 'Notices',
        'ge_label' : 'add-to-homescreen',
        'ge_noninteraction' : false
    };

    send_ga_event(data);
}


// Code to detect browser visibility super early on.
// Used in ads to load them on page load or wait until tab becomes visible.
window.browser_tab_is_visible = true;
detect_visibility_state();

document.addEventListener("visibilitychange", handle_browser_tab_visibility_change, false);
function handle_browser_tab_visibility_change(){
    detect_visibility_state();
}

function detect_visibility_state() {
    if(document.hidden) {
        browser_tab_is_visible = false;
        eraseCookie('browser_tab_is_visible');
    } else  {
        browser_tab_is_visible = true;
        createCookie('browser_tab_is_visible', 1, 1);
    }
}
// end browser tab visibility code

window.isTouchDevice = function(){
    try {  
        document.createEvent("TouchEvent");
        return true;  
    } catch (e) {  
        return false;  
    }  
}

window.is_member_logged_in = function(){
    if( getCookie('rcmg_guid') ){
        return true;
    }
    return false;
}



////////////////////////////////////////////////////////////////////////////////
// MAIN LOGIC //////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////
var siteName;

function main_init_master(){

    /**
     * GENERAL MASTER LOGIC
     */
    // Redirect to root on that query string per Ivan
    if( window.location.search == '?state=nwa' ){
        window.location.replace('/');
    }

    window.SITE_INFO = getSiteInfo();

    // init site settings
    setGlobalSiteConfigs();

    check_ios_app();


    // pings GA with an event if user is a gov acccount
    // if(SITE_INFO['name'] === 'politics') {
    //     checkIfGovAccount();
    // }

    /**
     * Sets ad settings, loads admiral and gpt all synchronous
     */
    console.log("ADS initAdsConfig");
    setGlobalAdsConfigs();
    (async () => {
        await load_admiral();
        await addMoatTag();
        await addGPTTag();
        evolok_init();
    })();

    // Evolok Metering Init
    // Evolok has to be the first thing that should be loading first.
    //Scripts are dependent from it
    console.log("ADMIRAL BEFORE EVOLOK INIT RUN LOAD ADS", window.run_loadAds);

    //ezoic var only will exist on rcscience 
    if(typeof ezoicTestActive !== 'undefined'){    
        //alert("ezoic version");
    }else{ //science legacy
    }

    // Run logic immediately or in doc ready, depending on where master is (head, or at end of body)
    if(document.querySelector("body")) {
        init_master();
    } else {
        $(function(){
            init_master();
        });
    }

    ////////////////////////////////////////////////////////////////////////////////
    // PRESERVE COMPATIBILITY //////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////

    window.siteName = SITE_INFO['name'];
    siteName = SITE_INFO['name'];
    window.sitePage = SITE_PAGE;
    window.gaTag = GA_TAG;
    window.site_title = SITE_INFO['site_title'];
    window.facebook_url = SITE_INFO['facebook_url'];
    window.twitter_url = SITE_INFO['twitter_url'];
    window.twitter_related = SITE_INFO['twitter_related'];
    window.global_site_url = SITE_INFO['global_site_url'];
    window.site_color = SITE_INFO['site_color'];
    window.FB_app_id = SITE_INFO['FB_app_id'];
    window.global_data_loc = SITE_INFO['global_data_loc'];
    //var revc_id = SITE_INFO['revc_id'];
    //var revc_w = SITE_INFO['revc_w'];
    //var revc_id_side = SITE_INFO['revc_id_side'];
    //var revc_w_side = SITE_INFO['revc_w_side'];
    window.zerg_id = SITE_INFO['zerg_id'];
    window.auto_list_ids = SITE_INFO['auto_list_ids'];
    window.spot_production_id = SITE_INFO['spot_production_id'];

    unregisterSwFiles();
}

/**
 * Delete any service workers that don't match our service worker
 */
function unregisterSwFiles(){
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations()
        .then(function(registrations) {
            for(let registration of registrations) {

                console.log("Check SW File", registration);
                if( !registration.active || !registration.active.scriptURL ){
                    registration.unregister();
                    return;
                }

                console.log("Check SW File Script URL", registration.active.scriptURL);
                if( registration.active.scriptURL != "https://www.realclearpolitics.com/service-worker.js"){
                    registration.unregister();
                    console.log("Unregister SW File");
                }
            }
        });
    }
}

function init_master() {

    warning_widget.init();
    warning_widget.check_ad_block_status();

    init_comscore();
    init_story_stream_related();

    init_menus_listeners();

    // Clicks on document that should close menus
    // click_outside_menus();

    if(typeof load_spot_recirculation == 'function') { load_spot_recirculation(); }

    // spot_right_rail_init();

    // sitesMenu();
    // sectionsMenu();
    // sectionsInnerMenu();
    // sitesMenuHover();
    // recommendedSitesMenuHover(); // Why does this function exist twice?

    recentItemsSlider();

    //LOAD DYNAMIC SOCIAL TOOLS IN TOOLS CONTAINER
    if( $('.socialBar').length > 0 ) {
        loadSocialTools();
    }

    AdsenseAds()
    .then(module => {
        window.loadAds = module.default;
        window.loadAds();
    });


    
    loadGotChosen();

    //loadPrimisWidget();
    loadMGIDWidget();

    $(document).ready(function(){
        //this is throwing an error if its not outside the doc ready
        // distroscale_init();
        //render_video_player();
    })

    markets_investingchannel();
    load_insticator();



    showComments();
    hideComments();
    showHideComments();

    // initSocialDrawer();

    onScroll();
    onResize();

    showMobileSearch();



    //M.B. TURNED OF STREAM TAG POPUPS FOR LAUNCH - TURN BACK ON POST LAUNCH
    //event checker - replaces width checks used to determine resolution
    //used to determine if a mouse event or touch event is fired
    if( !$('body').hasClass('home') && !$('body').hasClass('article-landing') && !$('body').hasClass('video-landing') ){
        StoryStreamsHover()
        .then(module => {
            module.default();
        });
    }

    toggleCBTsearch();

    customSelectBox();

    cbtSearch();

    viewSwitcher();

    dateMenu();

    displayStaff();

    siteSearch();

    //insert_tracking_admiral();


    /************************************************ DOC READY UTILITY FUNCTIONS **************************************************/


    //ANIMATE SCROLLING - REPLACES TRADITIONAL HTML BOOKMARKING BY CLICKING LINK AND SCROLLING DOWN TO BOOKMARK RATHER THAN JUMP DOWN
    $(".gamma > ul > li > a").click(function(e) {
        // Prevent a page reload when a link is pressed
        e.preventDefault();
        // Call the scroll function
        goToByScroll($(this).attr("id"));
    });

    loadInfinityAds(); //we wait for body class to load so we can check what section we're on

    // Google Site Translator
    // SITE_INFO['name'] == 'world' &&
    if( $('body.article').length > 0 ){
        setTimeout(function(){
            $('.goog-te-gadget-icon').removeClass('goog-te-gadget-icon');
            $('.goog-te-gadget-simple').html('<span style="vertical-align: middle;"><a class="goog-te-menu-value" href="javascript:void(0)"><span class="translate-text">Select Language</span><img class="election-full-site-arrow" src="/asset/img/grey-bg-chev.png"></a></span>');
            $('.goog-te-gadget-simple').css({ "background-color" : "transparent", "border-width" : "0", "padding-bottom" : "5px", "padding-top" : "5px" });
            $('.goog-te-gadget-simple .goog-te-menu-value').css({ "color" : "#999999" });
            $('.goog-te-menu-value img').css({ "margin-left" : "7px" });
        }, 2100);
    }else{
        setTimeout(function(){
            $('.goog-te-gadget-icon').removeClass('goog-te-gadget-icon');
            $('.goog-te-gadget-simple').html('<span style="vertical-align: middle;"><a class="goog-te-menu-value" href="javascript:void(0)"><span class="translate-text">Select Language</span><img class="election-full-site-arrow" src="/asset/img/grey-bg-chev.png"></a></span>');
        }, 2100);
    }

    //Newsletter Promo Pop-Up Handlers
    $("body").append('<div class="overlay_newsletter_promo"></div>');

    //Hide Member Pop-up - click anywhere outside pop-up to hide
    $(document).click(function(event) {
        if(!$(event.target).closest('#facebox').length) {
            if($('#facebox').is(":visible")) {
                $("body > .overlay_newsletter_promo").hide("fast");
            }else{
                $("body > .overlay_newsletter_promo").hide("fast");
            }
        }
    }); //END DOC .click - hide pop-up

    ///Newsletter widget I agree checkbox
    $(document).on('click', ':checkbox#i-agree' , function(e){
        console.log('i-');
        $('.right-options input:checkbox').prop('checked',this.checked);
    });


    // Temp disabled, seeing if we don't need it anymore
    //load_fb_sdk();

    toggleDonationsBanner();

    LazyInitBackgroundImages()
    .then(module => {
        module.default();
    });

    init_pwa_modal();

    ad_block_actions();

    init_service_worker();

    init_click_tracking();
}


function toggleDonationsBanner(){

    // if banner shown but not shown popup, dipslay popup
    if( $('.donations-pop-up-bg').length > 0 && readCookie('donations_banner_x2') != null && readCookie('donations_popup_x') == null ) {
        $('.donations-pop-up-bg').css({'display': 'block'});
        
        var current_hours = (new Date()).getHours();
        var hours_to_expire = 0;
        if( current_hours > 19 ){
            hours_to_expire = 8;
        }else{
            hours_to_expire = 23 - current_hours;
        }

        createCookie('donations_popup_x', '1', hours_to_expire, true);

        var data = {
            'ge_category' : 'Donations Campaign Popup',
            'ge_action' : 'Display',
            'ge_label' : SITE_INFO['name'],
            'ge_noninteraction': true,
        };

        send_ga_event(data);

        $('.donations-pop-up-bg').on('click', function(){
            $('.donations-pop-up-bg').css({'display': 'none'});
        });
        
        $('.donations-pop-up-close').on('click', function(){
            $('.donations-pop-up-bg').css({'display': 'none'});
        });
    }

    // if banner banner not shown, show it
    if( $('.donations_wrapper').length > 0 && readCookie('donations_banner_x2') == null ){
        $('.donations_wrapper').css({'display': 'block'});
        
        var current_hours = (new Date()).getHours();
        var hours_to_expire = 0;
        if( current_hours > 19 ){
            hours_to_expire = 8;
        }else{
            hours_to_expire = 23 - current_hours;
        }

        createCookie('donations_banner_x2', '1', hours_to_expire, true);

        var data = {
            'ge_category' : 'Donations Campaign Banner',
            'ge_action' : 'Display',
            'ge_label' : SITE_INFO['name'],
            'ge_noninteraction': true,
        };

        send_ga_event(data);

    }else if(window.innerWidth <= 768) { 
        $('#container .flex-viewport').css({'margin-top': '80px'});
    }

}


/*
*
* Install PWA on Safari or Android
* DATE: FEB 2 2020
* @ Add To HOME SCREEN
* */
function init_pwa_modal(){

    if(iOSSafari(navigator.userAgent) && siteName == 'politics'){

        if(window.navigator.standalone == true && typeof window.navigator !== 'undefined' && typeof window.navigator.standalone !== 'undefined' ){
            // if user is viewing the app from the Homescreen
            //we could target other behaivor
        } else {

            if(check_notif_cookie_to_display()){
                /*Temporarly disableing it because we at the moment there is no way to see if page has been bookedmarked on ios*/
                //msg = "Install this web app on your iPhone. Tap <img src='/asset/img/safari_action_icon.png'> and then <b>Add to Home Screen.</b>";
                //display_ios_modal(msg, 'safari');
            }
        }

    }
}

function append_manifest() {
    var link = document.createElement('link');
    link.rel = 'manifest';
    link.href = 'https://www.realclearpolitics.com/asset/vertical/rcp/manifest.json';
    document.head.appendChild(link);
}

//Service worker
function init_service_worker(){

    if ('serviceWorker' in navigator ) {

        /*navigator.serviceWorker.getRegistrations().
            then(function (registrations) {

                for (let registration of registrations) {
                    registration.unregister();

                }
            });*/

        if(siteName == 'politics'){
            append_manifest();

            window.addEventListener('load', function() {
                navigator.serviceWorker.register('/service-worker.js')
                .then(function(registration) {
                    // Registration was successful
                    console.log('ServiceWorker registration successful with scope: ', registration.scope);

                }, function(err) {
                    // registration failed :(
                    console.log('ServiceWorker registration failed: ', err);
                });

            });
        }

    }
}

var deferredPrompt;

window.addEventListener('beforeinstallprompt', function(e){
    e.preventDefault();
    deferredPrompt = e;

    //After detecting it can be installed show button
    install_app_init();
});

window.addEventListener('appinstalled', function(evt){
    //we know it has been installed hide button
    //trigger ga events to
    //console.log('a2hs installed');

    var data = {
        'ge_action' : 'Installed',
        'ge_category' : 'Notices',
        'ge_label' : 'add-to-homescreen',
        'ge_noninteraction' : false
    };
    send_ga_event(data);

});

window.install_app_init = function() {

    if( check_notif_cookie_to_display() && mobileAndTabletcheck() && siteName == 'politics' ){
        display_install_btn();
    }

}

/*
* UX
* O(ny display the notification on the 3rd visit
* */
window.check_notif_cookie_to_display = function(){
    var hp_pwa_notif_value = parseInt(readCookie('hp_pwa_notif') ) || createCookie('hp_pwa_notif', 1, 30);

    if(hp_pwa_notif_value && siteName == 'politics') {

        if (hp_pwa_notif_value < 3) {
            createCookie('hp_pwa_notif', hp_pwa_notif_value + 1, 30);
            return false;
        } else if (hp_pwa_notif_value == 3) {
            createCookie('hp_pwa_notif', hp_pwa_notif_value + 1, 30);
            return true;
        }

        return false;
    }
}

window.display_install_btn = function(){

    var msg = '<img src="/asset/img/rcp_pwa_icon_sm.png" alt="RCP App Icon" /> <span>Add <b>RCP</b> to <br> Home Screen!</span>';

    display_ios_modal(msg , 'sw-enabled');

    $(document).on('click', '.pwa-btn', function(e){
        deferredPrompt.prompt();

        deferredPrompt.userChoice
            .then( function(choiceResult) {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
                deferredPrompt = null;
            });
    });

    //Only show it once a month
    check_notif_cookie_to_display();

}


/*
* End of PWA INSTALL
* */




////////////////////////////////////////////////////////////////////////////////
// TEMPSHOW LIBRARY ////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/* Tempshow js notification library
*  v1.0 (c) 2018 RealClear
*/
window.Tempshow = function() {

    this.default = {
        width: '300px',       // any css width unit
        horizontal: 'right',  // left, center, right
        vertical: 'top',      // top, center, bottom
        type: 'info',         // warning, info, success, fail, or custom
        seconds: 10,          // default seconds until removed
        msg: '',              // message string
    };

    this.remove_timeouts = [];

    this.template = '<div id="tempshow_notif_{{notif_id}}" class="tempshow_notif_wrapper type_{{type}} horizontal_{{horizontal}} vertical_{{vertical}}" style="max-width:{{width}}">' +
        '<div class="msg">{{msg}}</div>' +
        '<div class="exit">X</div>' +
        '</div>';

    this.generate_id = function() {
        return Math.floor(Math.random() * Math.floor(9999999999));
    };

    this.create = function(new_options) {

        // if body isn't ready try again and exit early
        if( document.body === null ){
            console.log("BODY NOT READY FOR TEMP SHOW", document.body);
            setTimeout(function(){
                var tempshow = new Tempshow();
                tempshow.create(new_options);
            }, 250);
            return;
        }

        var html = this.template;

        // Apply options
        var options = this.default;

        for (var property in new_options) {
            if (new_options.hasOwnProperty(property)) {
                options[property] = new_options[property];
            }
        }

        html = html.replace('{{msg}}', options.msg);
        html = html.replace('{{type}}', options['type']);
        html = html.replace('{{horizontal}}', options.horizontal);
        html = html.replace('{{vertical}}', options.vertical);
        html = html.replace('{{width}}', options['width']);

        var notif_id = this.generate_id();

        html = html.replace('{{notif_id}}', notif_id);

        // Add new notification
        document.body.insertAdjacentHTML('beforeend', html);

        // Add click removal
        var exit_btn = document.querySelector('#tempshow_notif_'+notif_id+' .exit');

        this.addEvent(exit_btn, 'click', function() {

            parent.remove_existing(notif_id);

        }.bind(parent = this, notif_id));

        // Start removal timeout
        this.remove_timeouts.push(window.setTimeout(function() {

            parent.remove_existing(notif_id);

        }.bind(parent = this, notif_id), options.seconds * 1000));
    };

    this.remove_existing = function(notif_id) {

        // If 'animations' available in browser, do animation then remove at end of animation
        // If not available, just remove it right away

        var existing = document.querySelector('#tempshow_notif_'+notif_id);

        if(existing !== null) {

            if(this.isAnimationSupported()) {

                if( !this.hasClass(existing, 'remove') ) {

                    transitionEndEventNames.forEach( function(evt) {

                        existing.addEventListener(evt, function() {

                            existing.parentNode.removeChild(existing);

                        }.bind(existing), false);

                    }.bind(existing));

                    this.addClass(existing, 'remove');
                }

            } else {
                existing.parentNode.removeChild(existing);
            }
        }
    };

    // UTILITY

    this.addClass = function(el, className) {
        if (el.classList) el.classList.add(className);
        else if (!hasClass(el, className)) el.className += ' ' + className;
    };

    this.hasClass = function(el, className) {
        return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
    };

    var transitionEndEventNames = [
        'animationend',
        'webkitAnimationEnd',
        'oAnimationEnd',
        'MSAnimationEnd'
    ];

    this.isAnimationSupported = function() {
        var thisBody = document.body || document.documentElement,
            thisStyle = thisBody.style,
            support = thisStyle.animation !== undefined ||
                thisStyle.WebkitAnimation !== undefined ||
                thisStyle.MozAnimation !== undefined ||
                thisStyle.MsAnimation !== undefined ||
                thisStyle.OAnimation !== undefined;
        return support;
    };

    this.addEvent = function(el, type, handler) {
        if (el.attachEvent) el.attachEvent('on'+type, handler); else el.addEventListener(type, handler);
    };

};





////////////////////////////////////////////////////////////////////////////////
// EVOLOK NOTIFIERS ////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*
 *  Module:  Evolok Init Scripts - Notifiers/Modals
 *
 *  Launch:  06.07.18
 *
 */

if( typeof send_notifier_event != 'function' ){ //send ga events for all users => anonymous/logged in => upon accepting cookies/policies
    window.send_notifier_event = function(data)
    {
        // EXAMPLE INPUT:
        /*
      {
        'ge_action' : 'The What',
        'ge_category' : 'High Level - Event Name',
        'ge_label' : 'Descriptor/Values being tracked'
        'ge_index' : INT/index/counter => would allow you to track which element out of many/locations
        'ge_noninteraction' : Boolean => If empty/false(default) it would go again daily numbers/bounce rates("Intentional or NOT")
      }
      */
        //Wrap event tracking call to prevent premature termination of this function.
        try{
            _gaq.push(['_trackEvent', data['ge_category'], data['ge_action'], data['ge_label'], data['ge_index'], data['ge_noninteraction']]);
            // console.log('trackevent: '+data['ge_category']+' - '+data['ge_action']+' - '+data['ge_label']+' - '+data['ge_index']+' - '+data['ge_noninteraction']);
        } catch(err) {}
    }
}

function ad_block_actions(){

    $(document).on('click', '.jQ_allow', function(){
        $(".adblk-todo-wrapper").css({"display" : "block"});
    });

    $(document).on('click', '.jQ_close', function(){
        $(".adblk-todo-wrapper").css({"display" : "none"});
    });

    $(document).on('click', '.jQ_buy', function(){
        location.assign("//" + document.domain + "/subscriptions/index.html");
    });

    if(typeof window.EV !== 'undefined') {
        if(typeof EV.Event !== 'undefined'){
            EV.Event.on("ev.notifier.opened", function(){
                //Javascript functionality
                //console.log("::: AD WIDGET VISIBLE :::");

                //run until bootstrap modal, "notifier", is visible - get heights, recalculate, reset modal position for all devices
                /*get_ev_modal_ht = setInterval(function(){

              var notifier_ht = $(".modal-content").height();
              var notifier_half_ht = (notifier_ht / 2);

              if( $("body.ev-modals").length > 0 ){
                 var vp_ht = $(window).height();
                 var vp = (vp_ht / 2);
                 var modal_pos = (vp - notifier_half_ht);
                 var modal_pos_reset = (modal_pos-20);

                 $("body.ev-modals .modal").css({"top" : modal_pos_reset+"px"});

              }

              clearInterval(get_ev_modal_ht);

          }, 300);*/

                var notifier_segment;

                var get_notifier_segment = setInterval(function(){

                    if( $(".offer-wrapper").length > 0 ){
                        notifier_segment = $(".offer-wrapper").data("segments");

                        var check_send_ga_loaded = setInterval(function(){
                            if( typeof send_notifier_event == 'function' ){
                                var onload_notifier_data = {
                                    'ge_action' : 'AD Widget - Notifier Viewed - ' + 'Segment: ' + notifier_segment,
                                    'ge_category' : 'EV Subscriptions Notifier',
                                    'ge_label' : 'Viewed URL: ' + window.location.href,
                                    'ge_index' : null,
                                    'ge_noninteraction' : true
                                };
                                send_notifier_event(onload_notifier_data);
                                createCookie('notifierSegment',notifier_segment,'365');

                                clearInterval(check_send_ga_loaded);
                            } //if func() exists check
                        }, 250); //2.5 Second Intervals

                        clearInterval(get_notifier_segment);
                    }

                }, 500);

            });
        }
    }

    /* ADBLOCK AD WIDGET LOGIC */
    $(document).on('focus', '#email', function(){
        $(this).parents('.adb-clear-input form').addClass('focused');
        //$(".agree_container label, .agree_container input").show('fast');
        //$(".adb_agree_container label, .adb_agree_container input").css({ "display" : "inline !important" });
        $(".adb_agree_container").css({ "display" : "inline-block" });
    });

    $(document).on('blur', '#email', function(){
        if( $(this).val() == "" ){
            $(this).parents('.adb-clear-input form').removeClass('focused');
        }

        //$(".agree_container label, .agree_container input").hide('fast');
    });

    if(typeof window.EV !== 'undefined') {
        if(typeof EV.Event !== 'undefined'){
            EV.Event.on("ev.notifier.opened", function(){
                //Javascript functionality
                //console.log("::: AD WIDGET VISIBLE :::");
                $(".back-to-top").css({ "z-index" : "0" });

                window.get_modal_counts = setInterval(function(){

                    if( $(".offer-wrapper").length > 0 ){
                        var cur_count = parseInt($(".current-posts").html());
                        var total_count = $(".total-posts").html();
                        if( typeof total_count != "undefined" ){
                            var nLimit = parseInt(total_count.replace("*", ""));
                        }

                        if( cur_count > nLimit ){

                            $(".current-posts").html(nLimit);

                            var get_ev_modal_ht = setInterval(function(){

                                var notifier_ht = $(".modal-content").height();
                                var notifier_half_ht = (notifier_ht / 2);

                                if( $("body.ev-modals").length > 0 ){

                                    var vp_ht = $(window).height();
                                    var vp = (vp_ht / 2);
                                    var modal_pos = (vp - notifier_half_ht);
                                    var modal_pos_reset = (modal_pos-20);

                                    $("body.ev-modals .modal").css({"top" : modal_pos_reset+"px"});

                                    /*$(document).mouseup(function(e)
                                {
                                    var container = $(".modal");
                                    //console.info("THIS IS HAPPENING:::: ");

                                    // if the target of the click isn't the container nor a descendant of the container
                                    if (!container.is(e.target) && container.has(e.target).length === 0)
                                    {
                                        //container.hide();
                                        EV.Event.publish('ev.notifier.close');
                                        $(".ev-modals .modal-backdrop").hide();
                                        $(".adb-overlay").remove();
                                    }
                                });*/

                                }

                                clearInterval(get_ev_modal_ht);

                            }, 300);


                            $("body").prepend('<div class="adb-overlay"></div>');

                            // Blur text if exists
                            $('.article-body').addClass('blur-text');
                            $('.video-body-text').addClass('blur-text');
                            $('body.polls').addClass('blur-text');
                            $('body.maps').addClass('blur-text');

                            $(".modal-header-markets .close").hide();
                            $(".adblk-todo span a").last().hide();

                        }else{

                            var get_ev_modal_ht = setInterval(function(){

                                var notifier_ht = $(".modal-content").height();
                                var notifier_half_ht = (notifier_ht / 2);

                                if( $("body.ev-modals").length > 0 ){
                                    var vp_ht = $(window).height();
                                    var vp = (vp_ht / 2);
                                    var modal_pos = (vp - notifier_half_ht);
                                    var modal_pos_reset = (modal_pos-20);

                                    $("body.ev-modals .modal").css({"top" : modal_pos_reset+"px"});

                                    $("body.ev-modals .modal").css({ "width" : "100% !important", "height" : "100% !important" });

                                    $(document).mouseup(function(e)
                                    {
                                        var container = $(".modal");
                                        //console.info("THIS IS HAPPENING:::: ");

                                        // if the target of the click isn't the container nor a descendant of the container
                                        if (!container.is(e.target) && container.has(e.target).length === 0)
                                        {
                                            //container.hide();
                                            EV.Event.publish('ev.notifier.close');
                                            $(".ev-modals .modal-backdrop").hide();
                                        }
                                    });

                                }

                                clearInterval(get_ev_modal_ht);

                            }, 300);

                        } //end else

                    }

                    clearInterval(get_modal_counts);

                }, 300);

            });
        }
    }


    //var cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)notifierSegment\s*\=\s*([^;]*).*$)|^.*$/, "$1");

};

window.isInArray = function(value, array) {
    return array.indexOf(value) > -1;
}


////////////////////////////////////////////////////////////////////////////////
// GDPR REGULAIONS //////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

if( fire_gdpr_consent ) {

    /**
     * Load cookie consetn bot script
     */
    // try{
    //     var cookieScript    = document.createElement("script");
    //     cookieScript.type   = "text/javascript";
    //     cookieScript.id     = "cookiebot";
    //     cookieScript.src    = "https://consent.cookiebot.com/uc.js";
    //     cookieScript.setAttribute("data-cbid", "6dcaec77-f01e-45d9-a827-dce183129d73");
    //     cookieScript.setAttribute("data-blockingmode", "auto");
    //     document.head.appendChild(cookieScript);
    // }catch(e){
    //     console.log("cookieScript failed to load", e);
    // }

    /*
    * TITLE:      GDPR - COOKIECONSENT
    * LAUNCHED:   5/25/18
    * AUTHOR:     BROCK
    */

    if( typeof send_cc_event != 'function' ){ //send ga events for all users => anonymous/logged in => upon accepting cookies/policies
        function send_cc_event(data)
        {
            // EXAMPLE INPUT:
            /*
        {
          'ge_action' : 'The What',
          'ge_category' : 'High Level - Event Name',
          'ge_label' : 'Descriptor/Values being tracked'
          'ge_index' : INT/index/counter => would allow you to track which element out of many/locations
          'ge_noninteraction' : Boolean => If empty/false(default) it would go again daily numbers/bounce rates("Intentional or NOT")
        }
        */
            //Wrap event tracking call to prevent premature termination of this function.
            try{
                _gaq.push(['_trackEvent', data['ge_category'], data['ge_action'], data['ge_label'], data['ge_index'], data['ge_noninteraction']]);
                //console.log('trackevent: '+data['ge_category']+' - '+data['ge_action']+' - '+data['ge_label']);
            } catch(err) {}
        }
    }

    function updateConsent(gdpr_consent_details){

        var user_consent_details = readCookie('gdpr_consent_details');
    
        //user exists and logged in....
        rcmg_api_call('update_user_cookieconsent', {
            guid  : readCookie('rcmg_guid'),
            token : readCookie('rcmg_token'),
            cookieconsent : readCookie('rc_tos_consent'),
            cookiedetails : user_consent_details,
            userAgent  : navigator.userAgent
        }, function(response) {
    
            if (response.success) {
                // Successfully stored in DB.
    
                //console.log("::: country from cookie ::: " + response.data.consent_country);
                //console.log("::: timestamp from cookie ::: " + response.data.consent_timestamp);
    
                createCookie('gdpr_consent_stored', '1', '365');
    
            } else {
    
                //alert("Something Failed:::");
    
                // Could not authenticate. Deleted cookies.
                // Prompt with login.
                //clear_token_cookies();
    
            }
        });
    
    }

    var gdpr_block_consent = readCookie('gdpr_consent_country'); //User Country - User Must Consent to exist
    var user_consent_stored = readCookie('gdpr_consent_stored'); //User Consent Data Stored in DB - User is logged in/Logs in later after consent
    var gdpr_consent_details = readCookie('gdpr_consent_details'); //User Consent Data - Time of Consent/Country of Consent

    window.onload = function() { //needs onload wrapper to keep from firing too early
        if (window.jQuery) { //only run the following once jQuery is loaded else it will error
            /*
            * User has/is:
            *   a) Clicked I Agree while logged out OR not RCMG User(new)
            *   b) First Time Accepting - data not stored in DB
            */
            if( readCookie('rcmg_guid') && readCookie('rcmg_token') && readCookie('rc_tos_consent') && !user_consent_stored ){
                updateConsent(gdpr_consent_details);
            }
        }
    }
}












////////////////////////////////////////////////////////////////////////////////
// Facebox Library /////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*
 * Facebox (for jQuery)
 * version: 1.2 (05/05/2008)
 * @requires jQuery v1.2 or later
 *
 * Examples at http://famspam.com/facebox/
 *
 * Licensed under the MIT:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2007, 2008 Chris Wanstrath [ chris@ozmm.org ]
 *
 * Usage:
 *
 *  jQuery(document).ready(function() {
 *    jQuery('a[rel*=facebox]').facebox()
 *  })
 *
 *  <a href="#terms" rel="facebox">Terms</a>
 *    Loads the #terms div in the box
 *
 *  <a href="terms.html" rel="facebox">Terms</a>
 *    Loads the terms.html page in the box
 *
 *  <a href="terms.png" rel="facebox">Terms</a>
 *    Loads the terms.png image in the box
 *
 *
 *  You can also use it programmatically:
 *
 *    jQuery.facebox('some html')
 *
 *  The above will open a facebox with "some html" as the content.
 *
 *    jQuery.facebox(function($) {
 *      $.get('blah.html', function(data) { $.facebox(data) })
 *    })
 *
 *  The above will show a loading screen before the passed function is called,
 *  allowing for a better ajaxy experience.
 *
 *  The facebox function can also display an ajax page or image:
 *
 *    jQuery.facebox({ ajax: 'remote.html' })
 *    jQuery.facebox({ image: 'dude.jpg' })
 *
 *  Want to close the facebox?  Trigger the 'close.facebox' document event:
 *
 *    jQuery(document).trigger('close.facebox')
 *
 *  Facebox also has a bunch of other hooks:
 *
 *    loading.facebox
 *    beforeReveal.facebox
 *    reveal.facebox (aliased as 'afterReveal.facebox')
 *    init.facebox
 *
 *  Simply bind a function to any of these hooks:
 *
 *   $(document).bind('reveal.facebox', function() { ...stuff to do after the facebox and contents are revealed... })
 *
 */
(function($) {
    $.facebox = function(data, klass) {
        $.facebox.loading()

        if (data.ajax) fillFaceboxFromAjax(data.ajax)
        else if (data.image) fillFaceboxFromImage(data.image)
        else if (data.div) fillFaceboxFromHref(data.div)
        else if ($.isFunction(data)) data.call($)
        else $.facebox.reveal(data, klass)
    }

    /*
   * Public, $.facebox methods
   */

    $.extend($.facebox, {
        settings: {
            opacity      : 0,
            overlay      : true,
            loadingImage : 'https://s3.amazonaws.com/assets.realclearpolitics.com/images/facebox/loading.gif',
            closeImage   : 'https://s3.amazonaws.com/assets.realclearpolitics.com/images/facebox/closelabel.gif',
            imageTypes   : [ 'png', 'jpg', 'jpeg', 'gif' ],
            faceboxHtml  : '\
    <div id="facebox" style="display:none;"> \
      <div class="popup"> \
        <table> \
          <tbody> \
            <tr> \
              <td class="tl"/><td class="b"/><td class="tr"/> \
            </tr> \
            <tr> \
              <td class="b"/> \
              <td class="body"> \
                <div class="content"> \
                </div> \
                <div class="footer"> \
                  <a href="#" class="close"> \
                    <img src="https://s3.amazonaws.com/assets.realclearpolitics.com/images/facebox/closelabel.gif" title="close" class="close_image" /> \
                  </a> \
                </div> \
              </td> \
              <td class="b"/> \
            </tr> \
            <tr> \
              <td class="bl"/><td class="b"/><td class="br"/> \
            </tr> \
          </tbody> \
        </table> \
      </div> \
    </div>'
        },

        loading: function() {
            init()
            if ($('#facebox .loading').length == 1) return true
            showOverlay()

            $('#facebox .content').empty()
            $('#facebox .body').children().hide().end().
            append('<div class="loading"><img src="'+$.facebox.settings.loadingImage+'"/></div>')

            $('#facebox').css({
                top:  getPageScroll()[1] + (getPageHeight() / 10),
                left: 385.5
            }).show()

            $(document).bind('keydown.facebox', function(e) {
                if (e.keyCode == 27) $.facebox.close()
                return true
            })
            $(document).trigger('loading.facebox')
        },

        reveal: function(data, klass) {
            $(document).trigger('beforeReveal.facebox')
            if (klass) $('#facebox .content').addClass(klass)
            $('#facebox .content').append(data)
            $('#facebox .loading').remove()
            $('#facebox .body').children().fadeIn('normal')
            $('#facebox').css('left', $(window).width() / 2 - ($('#facebox table').width() / 2))
            $(document).trigger('reveal.facebox').trigger('afterReveal.facebox')
        },

        close: function() {
            $(document).trigger('close.facebox')
            return false
        }
    })

    /*
   * Public, $.fn methods
   */

    $.fn.facebox = function(settings) {
        init(settings)

        function clickHandler() {
            $.facebox.loading(true)

            // support for rel="facebox.inline_popup" syntax, to add a class
            // also supports deprecated "facebox[.inline_popup]" syntax
            var klass = this.rel.match(/facebox\[?\.(\w+)\]?/)
            if (klass) klass = klass[1]

            fillFaceboxFromHref(this.href, klass)
            return false
        }

        return this.click(clickHandler)
    }

    /*
   * Private methods
   */

    // called one time to setup facebox on this page
    function init(settings) {
        if ($.facebox.settings.inited) return true
        else $.facebox.settings.inited = true

        $(document).trigger('init.facebox')
        makeCompatible()

        var imageTypes = $.facebox.settings.imageTypes.join('|')
        $.facebox.settings.imageTypesRegexp = new RegExp('\.' + imageTypes + '$', 'i')

        if (settings) $.extend($.facebox.settings, settings)
        $('body').append($.facebox.settings.faceboxHtml)

        var preload = [ new Image(), new Image() ]
        preload[0].src = $.facebox.settings.closeImage
        preload[1].src = $.facebox.settings.loadingImage

        $('#facebox').find('.b:first, .bl, .br, .tl, .tr').each(function() {
            preload.push(new Image())
            preload.slice(-1).src = $(this).css('background-image').replace(/url\((.+)\)/, '$1')
        })

        $('#facebox .close').click(function(){
            $('.overlay').hide();
            $.facebox.close
        });

        $('#facebox .close').click($.facebox.close);

        $('#facebox .close_image').attr('src', $.facebox.settings.closeImage)
    }

    // getPageScroll() by quirksmode.com
    function getPageScroll() {
        var xScroll, yScroll;
        if (self.pageYOffset) {
            yScroll = self.pageYOffset;
            xScroll = self.pageXOffset;
        } else if (document.documentElement && document.documentElement.scrollTop) {   // Explorer 6 Strict
            yScroll = document.documentElement.scrollTop;
            xScroll = document.documentElement.scrollLeft;
        } else if (document.body) {// all other Explorers
            yScroll = document.body.scrollTop;
            xScroll = document.body.scrollLeft;
        }
        return new Array(xScroll,yScroll)
    }

    // Adapted from getPageSize() by quirksmode.com
    function getPageHeight() {
        var windowHeight
        if (self.innerHeight) { // all except Explorer
            windowHeight = self.innerHeight;
        } else if (document.documentElement && document.documentElement.clientHeight) { // Explorer 6 Strict Mode
            windowHeight = document.documentElement.clientHeight;
        } else if (document.body) { // other Explorers
            windowHeight = document.body.clientHeight;

        }
        return windowHeight
    }

    // Backwards compatibility
    function makeCompatible() {
        var $s = $.facebox.settings

        $s.loadingImage = $s.loading_image || $s.loadingImage
        $s.closeImage = $s.close_image || $s.closeImage
        $s.imageTypes = $s.image_types || $s.imageTypes
        $s.faceboxHtml = $s.facebox_html || $s.faceboxHtml
    }

    // Figures out what you want to display and displays it
    // formats are:
    //     div: #id
    //   image: blah.extension
    //    ajax: anything else
    function fillFaceboxFromHref(href, klass) {
        // div
        if (href.match(/#/)) {
            var url    = window.location.href.split('#')[0]
            var target = href.replace(url,'')
            $.facebox.reveal($(target).clone().show(), klass)

            // image
        } else if (href.match($.facebox.settings.imageTypesRegexp)) {
            fillFaceboxFromImage(href, klass)
            // ajax
        } else {
            fillFaceboxFromAjax(href, klass)
        }
    }

    function fillFaceboxFromImage(href, klass) {
        var image = new Image()
        image.onload = function() {
            $.facebox.reveal('<div class="image"><img src="' + image.src + '" /></div>', klass)
        }
        image.src = href
    }

    function fillFaceboxFromAjax(href, klass) {
        $.get(href, function(data) { $.facebox.reveal(data, klass) })
    }

    function skipOverlay() {
        return $.facebox.settings.overlay == false || $.facebox.settings.opacity === null
    }

    function showOverlay() {
        if (skipOverlay()) return

        if ($('facebox_overlay').length == 0)
            $("body").append('<div id="facebox_overlay" class="facebox_hide"></div>')

        $('#facebox_overlay').hide().addClass("facebox_overlayBG")
            .css('opacity', $.facebox.settings.opacity)
            .click(function() { $(document).trigger('close.facebox') })
            .fadeIn(200)
        return false
    }

    function hideOverlay() {
        if (skipOverlay()) return

        $('#facebox_overlay').fadeOut(200, function(){
            $("#facebox_overlay").removeClass("facebox_overlayBG")
            $("#facebox_overlay").addClass("facebox_hide")
            $("#facebox_overlay").remove()
        })


        return false
    }

    /*
   * Bindings
   */

    $(document).bind('close.facebox', function() {
        $(document).unbind('keydown.facebox')
        $('#facebox').fadeOut(function() {
            $('#facebox .content').removeClass().addClass('content')
            hideOverlay()
            $('#facebox .loading').remove()
        })
    })

})(jQuery);











////////////////////////////////////////////////////////////////////////////////
// FARK WIDGET /////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////


window.fark_widgets_init = function() {

    if( readCookie('evaf') != null && parseInt(readCookie('evaf')) == 1 ) {
        console.log('ad_free exit fark_widgets_init');
        return;
    }

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    // temporary override of IC off with Fisher "malvert" flag 6/8/2019
    if( NO_IC ) { 
        return;
    }

    var allowed_sites = [
        'politics',
        'markets',
        'history',
        'defense',
        'world',
        'science',
    ];

    if( allowed_sites.indexOf(SITE_INFO['name']) == -1 ){
        return;
    }

    FarkWidget()
    .then(module => {
        module.default();
    });

}













////////////////////////////////////////////////////////////////////////////////
// FLOATING LEADERBOARD ////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

//M.B. ADDED 12.5.17 -- FLOATING LEADERBOARD AD/RIGHTRAIL AD_BOX_TOP
//A.A. REWORKED AND CLEANED UP 11.15.18
/* floating leaderboard ad && floating right rail ad box top */
//if( $('body.article').length > 0 ){ //only article pages -- might need to kill /articles and long-format pages???
//console.log('floater func enabled.......');

//when doc is ready then check body class - if checks true do following...
$(document).ready(function(){

    var settings = {};

    LeaderboardScroll()
    .then(module => {
        module.default(settings);
    });

}); //end doc ready

// Another floating ads class... may be redundant? /////////////////////////////











////////////////////////////////////////////////////////////////////////////////
// ADS FUNCTIONS ///////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function init_comscore(){
    var script = document.createElement('script');
    script.src = '//a.pub.network/core/fscomscore.js';
    script.setAttribute('data-cfasync', 'false');
    document.head.appendChild(script);
}


// Special Ad Vendors //////////////////////////////////////////////////////////

function loadGotChosen(){

    if( readCookie('evaf') != null && parseInt(readCookie('evaf')) == 1 ) {
        console.log('ad_free exit loadGotChosen');
        return;
    }

    var hideGoChosen = document.getElementsByClassName('hide-got-chosen-ads');
    if (hideGoChosen.length > 0) {
        return;
    }

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    } 

    if(evolok_init_finished) {

        if(!evolok_do_ads) {
            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }

    var $has_comments = $('#comments-container').length;
    var $is_polls = $('body.polls').length;

    if($has_comments > 0 || $is_polls > 0){

        if( !$('#gotChosen').length && SITE_INFO['gotchosen_id']!= "" ){ //this is to prevent duplicated widgets being created

            GotChosen()
            .then(module => {
                module.default();
            });
        }
    }
}

window.loadZergOrRev = function() {

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads) {
            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }

    //if( $("#revContentWidget").length>0 ){
    //IF WE HAVE A REVC_ID AND WE'RE ON AN ARTICLE PAGE
    var isarticle = $('body.article').length;
    var ispoll = $('body.polls').length;
    var isSponsoredPage = $('body.sp_content').length; //if sponsored page do not want any ads/ad widgets

    if(SITE_INFO['revc_id']!="" && isSponsoredPage==0 && (isarticle>0 || ispoll>0)){

        //if NOT hiding 3rd party ads then load rev/zerg ads
        if( $(".data-no-ads").length == 0 ){
            if(SITE_INFO['zerg_id']==''){
                //loadRevContentWidgets();
            }else{ //use zerg if we have it
                loadZergWidgets();
            }
        }

    }
}

window.loadZergWidgets = function(){

    //REV CONTENT BELOW MAIN SECTION
    $f = $('div.alpha');
    $f.append("<div class='clear'></div><div id='zergnet-widget-"+SITE_INFO['zerg_id']+"'></div>");
    //(function() {
    var zergnet = document.createElement('script');
    zergnet.type = 'text/javascript'; zergnet.async = true;
    zergnet.src = (document.location.protocol == "https:" ? "https:" : "http:") + '//www.zergnet.com/zerg.js?id='+SITE_INFO['zerg_id'];
    var znscr = document.getElementsByTagName('script')[0];
    znscr.parentNode.insertBefore(zergnet, znscr);
    //})();

}

window.loadRevContentWidgets = function(){

    //REV CONTENT BELOW ARTICLE
    //$f = $('#revContentWidget');
    $f = $('div.alpha');

    //$f.after("<div id='"+revc_id+"'></div>");
    $f.append("<div class='clear'></div><div id='"+SITE_INFO['revc_id']+"'></div>");
    var referer="";
    try{
        if(referer=document.referrer,"undefined"==typeof referer)
            throw"undefined"
    }catch(exception){
        referer=document.location.href,(""==referer||"undefined"==typeof referer)&&(referer=document.URL)
    }
    referer=referer.substr(0,700);
    var rcel = document.createElement("script");
    rcel.id = 'rc_' + Math.floor(Math.random() * 1000);
    rcel.type = 'text/javascript';
    rcel.src = "https://trends.revcontent.com/serve.js.php?w="+SITE_INFO['revc_w']+"&t="+rcel.id+"&c="+(new Date()).getTime()+"&width="+(window.outerWidth || document.documentElement.clientWidth)+"&referer="+referer;
    rcel.async = true;
    if( $('body.article.long').length==0 ){
        var rcds = document.getElementById(SITE_INFO['revc_id']);
        rcds.appendChild(rcel);
    }


    if(SITE_INFO['revc_id_side']!=''){ //LOAD SIDEBAR WIDGET IF WE HAVE CODE

        //REV CONTENT SIDEBAR
        $('div.beta').append("<div id='"+SITE_INFO['revc_id_side']+"'></div>");
        var referer="";
        try{
            if(referer=document.referrer,"undefined"==typeof referer)
                throw"undefined"
        }catch(exception){
            referer=document.location.href,(""==referer||"undefined"==typeof referer)&&(referer=document.URL)
        }
        referer=referer.substr(0,700);
        var rcel = document.createElement("script");
        rcel.id = 'rc_' + Math.floor(Math.random() * 1000);
        rcel.type = 'text/javascript';
        rcel.src = "https://trends.revcontent.com/serve.js.php?w="+SITE_INFO['revc_w_side']+"&t="+rcel.id+"&c="+(new Date()).getTime()+"&width="+(window.outerWidth || document.documentElement.clientWidth)+"&referer="+referer;
        rcel.async = true;
        if( $('body.article.long').length==0 ){
            var rcds = document.getElementById(SITE_INFO['revc_id_side']);
            rcds.appendChild(rcel);
        }
    }
}

window.investingChannel_init = function(){

    console.log("ADMIRAL investingChannel_init");

    // Put close button on select ads
    // and Remove id of any ad that has a close cookie still active
    if(typeof SITE_INFO['ic_ads_close'] !== 'undefined') {

        SITE_INFO['ic_ads_close'].forEach(function(ic_ad) {

            if( $("body").hasClass(ic_ad['body_class']) ) {

                ic_ad['ads'].forEach(function(ad) {

                    $el = $('#'+ad);
                    if($el.length > 0){

                        // If cookie exists, remove id
                        if(readCookie(ad+'_close-ad')) {

                            $el.attr('id', 'closed_ic_ad');

                        } else { // If no cookie, place close btn

                            $el.attr('style', 'position:relative;');

                            var closer = '<div class="close-the-ad">&times;</div>';

                            $el.append(closer);

                            $el.find('.close-the-ad').click(function() {
                                // on closing ad, create a cookie based on the classes of the element
                                // the cookie is to be used by anyone else needing to check for this
                                //var ad_element = $(this).closest('.RC-AD');
                                var ad_element = $(this).parent();
                                var cookie_name = ad_element.attr('id')+'_close-ad';
                                console.log('cookie_name: '+cookie_name);
                                createCookie(cookie_name, $(ad_element).prop('nodeName')+'_'+cookie_name, 1);
                                $(ad_element).hide();
                            });
                        }
                    }
                });
            }
        });
    }

    // Init investingchannel

    if(typeof InvestingChannelQueue != 'undefined'){
        InvestingChannelQueue = window.InvestingChannelQueue || [];

        InvestingChannelQueue.push(function() {
            window.ic_page = InvestingChannel.UAT.Run("350ec4ce-2cd7-4361-8d99-f004438137c2");
        });
    }

    return;
}

function markets_investingchannel() {

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads) {

            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }

    if( readCookie('two_weeks_adfree') ){ return false; }

    if(SITE_INFO['name'] == 'markets' && !NO_IC ) {

        if( !$('body').hasClass('new_ic_uat') ){

            var invc_bylineAd = "<div class=\"invc-byline-ad\"><!-- Site: RealClearMarkets.RealClearMarkets, Zone: equities_news, Size 234x20, Multiple sizes: N/A --><div class=\"sponsored-text-list\" style=\"font-size:.55em;font-color:#777\">Advertisement</div><script src='//ads.investingchannel.com/adtags/realclearmarkets/equities_news/234x20.js' type='text/javascript' charset='utf-8'></script></div>";

            var invc_lcAd = "<!-- Site: RealClearMarkets.RealClearMarkets, Zone: equities_news, Size 125x125, Multiple sizes: N/A --><script src='//ads.investingchannel.com/adtags/realclearmarkets/equities_news/125x125.js' type='text/javascript' charset='utf-8'></script>";

            var invc_bannerAd = "<!-- Site: RealClearMarkets.RealClearMarkets, Zone: searchbx, Size 88x31, Multiple sizes: N/A --><script src='//ads.investingchannel.com/adtags/realclearmarkets/searchbx/88x31.js?kval=searchbx' type='text/javascript' charset='utf-8'></script>";

            if( $(".sharepoint-wrapper").length>0 ){
                $(".article-auth").css({ "margin-bottom" : "45px" });
            }

            if(typeof load_investingchannel_88x31 == 'function') {load_investingchannel_88x31(); }
            if(typeof load_investingchannel_300 == 'function') {load_investingchannel_300(); }
        }
        //Dynamically load in Inv. Channel Ads

        // disabled 1/6/2019 ROWLAND
        //$('.article-auth').after( invc_bylineAd );
        //$('.invc-lc-ad').append( invc_lcAd );
        //$('.invc-header-ad').append( invc_bannerAd );

    }

}

//LOAD INFINITY "Before you Go" UNIT (was pop-under)
// No need to have evolok manage this until politics ready
function loadInfinityAds(){

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads) {
            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }    

    if(SITE_INFO['name']=='politics'){

        InfinityAds()
        .then(module => {
            module.default();
        });
    }
}

function loadMGIDWidget(){

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads) {
            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }


    if(SITE_INFO['name']=='science'){
        var cur_body_class = document.body.getAttribute('class').split(/\s+/); //grab body class
        if( cur_body_class[0]=='article'){

            MgidScienceArticle()
            .then(module => {
                module.default();
            });

        }
    }
}

window.loadPrimisWidget = function(){

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads) {
            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }


    if(SITE_INFO['name']=='science'){
        var cur_body_class = document.body.getAttribute('class').split(/\s+/); //grab body class
        if( cur_body_class[0]=='article'){

            (function() {

                widget = '<div id="primis_target"></div>';
                target = 'div.article-body #comments-container';
                $(target).after(widget);


                var sc = document.createElement('script');
                sc.type = 'text/javascript';
                sc.async = true;
                sc.src = '//live.sekindo.com/live/liveView.php?s=99276&cbuster=[CACHE_BUSTER]&pubUrl=[PAGE_URL_ENCODED]&x=[WIDTH]&y=[HEIGHT]&vp_content=plembed128dgxvmnzqs&vp_template=5280&subId=[SUBID_ENCODED]';
                sc.charset = 'utf-8';
                var s = document.getElementById('primis_target');
                s.appendChild(sc, s);

            })();


        }
    }
}











////////////////////////////////////////////////////////////////////////////////
// SOCIAL FUNCTIONS ////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function loadSocialTools()
{
    SocialTools()
    .then(module => {
        module.default();
    });
}//end socialTools function

window.loadSocialTools = loadSocialTools;




window.rctools_initEmailControls = function(parent,title){

    //*CURRENT* EMAIL CONTAINER TARGET ELEMENT
    var emailBox = parent.find('.toolset_drawer .send-btn-form');

    //SET TRIGGER FOR + ICON
    var gindex = 1;
    emailBox.find(".addEmailBtn").click(function(){
        gindex++;
        rctools_addField(gindex,emailBox);
        emailBox.find('[data-index="' + (gindex).toString() + '"]').focus();
    });

    //SET TRIGGER TO ADD NEW FIELDS WHEN HITTING RETURN AND COMMA
    emailBox.on('keydown', 'input', function (event) {
        if (event.which == 13 || event.which == 188) {
            event.preventDefault();
            var $this = $(event.target);
            var index = parseFloat($this.attr('data-index'));
            $('[data-index="' + (index + 1).toString() + '"]').focus();
            if(index >=1){
                gindex++;
                rctools_addField(gindex,emailBox)
                emailBox.find('[data-index="' + (gindex).toString() + '"]').focus();
            }
        }
    });


    emailBox.find("#sendBtn").unbind("click").click(function(e){

        var emailForm = $(this).parent().parent();

        e.preventDefault();

        //emailBox.append("<h2>orale guey</h2>");
        //var title = $("title").html();

        emailForm.find(".emailLoader").show();
        emailForm.find(".fieldset").css({ "opacity" : "0.3" });

        //get site name via url
        var getUrl = document.domain;
        //strip params off url to get raw site name
        var url = getUrl.replace(".com","");
        var site = url.replace("www.","");
        var siteName = site.replace("www1.","");

        //Get the data-feed-url from the div.hover-social, or fall back on window.location.href
        var pageLink = parent.parent().parent().parent().attr('data-feed-url') || window.location.href;
        //Get the data-feed-name from the div.hover-social, or fall back on title passed in to the function
        title = parent.parent().parent().parent().attr('data-feed-name') || title;



        var name = emailForm.find("#senderName").val();
        var sEmail = emailForm.find("#senderEmail").val();
        var recEmail = emailForm.find("#recpEmail").val();
        var msg = emailForm.find("#optMessage").val();
        var send = true;

        if( name == "" ){
            //alert ('Please Add Name');
            emailForm.find("#msgBox").html("Please Add Name");
            emailForm.find("#msgBox").show().delay(3000).fadeOut();
            emailForm.find(".emailLoader").hide();
            emailForm.find(".fieldset").css({ "opacity" : "1" });
            send = false;
        }
        if( sEmail == "" ){
            //alert('Please Enter Email');
            emailForm.find("#msgBox").html("Please Enter Email");
            emailForm.find("#msgBox").show().delay(3000).fadeOut();
            emailForm.find(".emailLoader").hide();
            emailForm.find(".fieldset").css({ "opacity" : "1" });
            send = false;
        }
        if( recEmail == "" ){
            //alert('Please Enter Recipients Email');
            emailForm.find("#msgBox").html("Please Enter Recipients Email");
            emailForm.find("#msgBox").show().delay(3000).fadeOut();
            emailForm.find(".emailLoader").hide();
            emailForm.find(".fieldset").css({ "opacity" : "1" });
            send = false;
        }

        if( msg != "" ){
            if (emailForm.find('#optMessage').val().match(/<(\w+)((?:\s+\w+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/) || emailForm.find('#optMessage').val().match(/http/i) || emailForm.find('#optMessage').val().match(/www./i)) {
                //alert('msg has html');
                emailForm.find('#msgBox').html("NO Links or HTML allowed. Please re-enter Message.");
                emailForm.find("#msgBox").show().delay(3000).fadeOut();
                emailForm.find(".emailLoader").hide();
                emailForm.find(".fieldset").css({ "opacity" : "1" });
                var msg = emailForm.find("#optMessage").val("");
                send = false;
            }
        }

        //var emailArray = new Array('idelgado@rcp.com','delgado.ivan@gmail.com', 'mb@rcp.com');
        var emailArray = new Array();
        emailForm.find("#addEmailForm input").each(function(i){
            var emails = $(this).val();
            emailArray.push(emails);
        });
        emailArray.push(recEmail); //append first field

        //if(send == true){
        if(rctools_verifyEmail(sEmail) && rctools_verifyEmail(emailArray)){
            var sEmailLen = sEmail.length;
            var recEmailLen = recEmail.length;
            if(sEmailLen <= 200 && recEmailLen <= 200){

                if(send == true || send == "true"){
                    $.getJSON(window.location.protocol+"//util.realclearpolitics.com/email/app/sendemail.php?jsoncallback=?",{
                        name:name,
                        sEmail:sEmail,
                        recEmail:recEmail,
                        msg:msg,
                        siteName:siteName,
                        pageLink:pageLink,
                        emailArray:emailArray,
                        title:title
                    }, function(data) {

                        $.each(data, function(key,val){
                            if(key == "response"){
                                if(val == 1){

                                    emailForm.find(".emailLoader").hide();

                                    var name = $(".fieldset #senderName").val("");
                                    var sEmail = $(".fieldset #senderEmail").val("");
                                    var recEmail = $(".fieldset #recpEmail").val("");
                                    var msg = $(".fieldset #optMessage").val("");

                                    emailBox.find("#msgBox").html("Your email has been sent.");

                                    emailBox.find("#msgBox").show().delay(4000).fadeOut();

                                    //$('.toolset_drawer').delay(5000).hide(200);

                                }else if(val == 2){
                                    //alert('Please wait one minute before sending another email to a friend');
                                    emailForm.find("#msgBox").html("Please wait one minute before sending another email to a friend");
                                    emailForm.find("#msgBox").show().delay(3000).fadeOut();

                                    emailForm.find(".emailLoader").hide();
                                    emailForm.find(".fieldset").css({ "opacity" : "1" });
                                }else if(val == 3){
                                    emailForm.find("#msgBox").html("Error: Email did not send.  Please <a style='font-weight:bold; color:#FFFFFF; text-decoration:underline;' href='http://www.realclearpolitics.com/contact.html'>Contact Us</a> for support.");
                                    emailForm.find("#msgBox").show().delay(9000).fadeOut();

                                    emailForm.find(".emailLoader").hide();
                                    emailForm.find(".fieldset").css({ "opacity" : "0" });

                                    //parent.find('.toolset_drawer').delay(5000).hide(200);
                                }else{
                                    //alert('Error: Please try again');
                                    $("#msgBox").html("Error: Please try again");
                                    $("#msgBox").show().delay(3000).fadeOut();
                                    emailForm.find(".emailLoader").hide();
                                    emailForm.find(".fieldset").css({ "opacity" : "1" });
                                }
                            }
                        });
                    });
                } //end if send is true - no errors

            }else{
                //alert('Email is too long.  Please try again.');
                emailForm.find("#msgBox").html("Email is too long. Please try again.");
                emailForm.find("#msgBox").show().delay(3000).fadeOut();

                emailForm.find(".emailLoader").hide();
                emailForm.find(".fieldset").css({ "opacity" : "1" });
            }



        }else{
            //alert('Invalid Email. Please correct and try again');
            emailForm.find("#msgBox").html("Invalid Email. Please correct and try again.");
            emailForm.find("#msgBox").show().delay(3000).fadeOut();

            emailForm.find(".emailLoader").hide();
            emailForm.find(".fieldset").css({ "opacity" : "1" });
        }
        //} //end if send - no errors

    }); //end send to friend handler
}

//SENDMAIL HELPER FUNCS
window.rctools_addField = function(gindex,box){
    var addEmailInput = '<input id="recpEmail" name="recEmail" type="text" data-index="'+gindex+'" /><br />';
    box.find("#addEmailForm").append(addEmailInput);
}

window.rctools_verifyEmail = function(email) {

    // Validate an email address, or an array of addresses.
    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/;
    if(email.constructor === Array) {
        for(var i=0; i<email.length;i++) {
            if(!emailReg.test(email[i])) {
                return false;

            }
        }
        return true;
    } else {
        return emailReg.test(email);
    }
}

/*function get_pageviews() {
  var $pv = $('.socialBar-clicks');

  if($pv.length > 0 && $('body.polls').length == 0)
  {
    $.ajax({
      dataType: 'json',
      url: window.location.href.substring(0, window.location.href.lastIndexOf('.') ) + '.json',
      success: function(data)
      {
        console.log(data);
        var pageviews = 0;
        var pageviews_text = '';
        if(data.hasOwnProperty('today_pageviews')) {
          pageviews += parseInt(data['today_pageviews']);
        }
        if(data.hasOwnProperty('total_pageviews')) {
          pageviews += parseInt(data['total_pageviews']);
        }
        if(pageviews < 1) {
          $pv.hide();
          $('.socialBar-divide').hide();
        } else {
          pageviews_text = social_number_format(pageviews);
        }
        $pv.html(pageviews_text + ' <span class="label">Views</span>');
      },
      timeout: 2000,
      error: function(jqXHR, textStatus, errorThrown) {
        $pv.hide();
        $('.socialBar-divide').hide();
      }
    });
  } else {
    $('.socialBar-divide').hide();
  }
}*/

// window.social_number_format = function(num) {

//     if(num < 1000) {
//         return num;
//     } else if(num < 10000) {
//         return (Math.floor(num/100) / 10) + 'k';
//     } else if(num < 1000000) {
//         return Math.floor(num/1000) + 'k';
//     } else if(num < 10000000) {
//         return (Math.floor(num/100000) / 10) + 'M';
//     } else if(num < 1000000000) {
//         return Math.floor(num/1000000) + 'M';
//     } else {
//         return (Math.floor(num/100000000) / 10) + 'B'; // It could happen
//     }
// }

/*function populateShares(){
  $(".socialBar").each(function() {
    if($(this).parent().find('.socialBar-shares').length > 0 ||
      $(this).parent().parent().next('.socialBar-bottom-counts').length > 0 ||
      $(this).parent().parent().next('.socialBar-top-counts').length > 0 ||
      $(this).parent().parent().next('.socialBar-mobile-counts').length > 0
    ) {

      //console.log('length: '+$(this).parent().find('.socialBar-shares').length);
      //console.log('length: '+$(this).parent().parent().next('.socialBar-bottom-counts').length);
      populateSharesSingle($(this));
    }
  });
}

function populateSharesSingle(container){
  var shareUrl = '';
  if( typeof container.attr("data-src-url") !=="undefined" ){
    shareUrl = container.attr("data-src-url");
  }else{
    shareUrl = window.location.href;
  }

  //console.log("This Here URL... " + shareUrl);

  $.ajax({
    url: 'https://graph.facebook.com/?id='+shareUrl,
    dataType: 'jsonp',
    ref: container,
    success: function(data){
      var ref = this.ref;
      // New data structure, post 8/19/2016
      var share = data.share;
      //console.log(share);
      var shareCount = 0;
      if( typeof share !== 'undefined') { // case where no shares available yet
        shareCount = share.share_count;
        if( shareCount == '' || shareCount == 'undefined' || shareCount == undefined ){
          shareCount = 0;
        }else{
          shareCount = shareCount;
        }
      }
      ref.fbDone=true;
      ref.fbShares = shareCount;
      socialDone(ref);
    },
    timeout: 4000,
    error: function(jqXHR, textStatus, errorThrown) {
      this.ref.fbDone=true;
      this.ref.fbShares = 0;
      socialDone(this.ref);
    }
  });

  $.ajax({
      url: 'https://www.linkedin.com/countserv/count/share?url='+shareUrl+'&callback=myCallback&format=jsonp',
      ref: container,
      dataType: "jsonp",
      jsonpCallback: "myCallback",
      success: function (data) {
        var ref = this.ref;
      $(data).each(function(i,k){
        var linCount = k.count;
        ref.linDone=true;
        ref.linkedCount = linCount;
        socialDone(ref);
      });
      },
      timeout: 4000,
      error: function(jqXHR, textStatus, errorThrown) {
        this.ref.linDone=true;
        this.ref.linkedCount = 0;
        socialDone(this.ref);
      }
  });

}*/

// window.socialDone = function(c){
//     //M.B. updated 9.8.16 - removing twitter from totals as they do not offer counts anymore
//     if( c.fbDone == true && c.linDone == true ){
//         //if( c.fbDone == true && c.twtDone == true && c.linDone == true ){
//         //console.log('successful c:');
//         //console.log(c);
//         //total shared count from all 3 social networks
//         //console.log('fb: '+c.fbShares + ', twt: ' + c.twtCount + ', li: ' + c.linkedCount);

//         //M.B. UPDATED 9.8.16 - NO MORE TWITTER
//         var totalSharesCount = c.fbShares + c.linkedCount;
//         //var totalSharesCount = c.fbShares + c.twtCount + c.linkedCount;
//         //formatted version of the total share count - 12,365 total == 12.3k
//         var totalCount = nFormatter(totalSharesCount);

//         if( totalSharesCount > 49 ){
//             //$(".socialBar-shares").html(totalCount + ' <span class="label">Shares</span>');
//             //$(".socialBar-divide").css({"display" : "inline-block"});
//             //$(".socialBar-shares").css({"display" : "inline-block"});
//             c.parent().find(".socialBar-shares").each(function() {
//                 $(this).html(totalCount + ' <span class="label">Shares</span>');
//                 $(this).css({"display" : "inline-block"});
//                 if($(this).parent().find('.socialBar-clicks').is(':visible')) {
//                     $(this).parent().find('.socialBar-divide').css({"display" : "inline-block"});
//                 }
//             });
//             c.parent().parent().next('.socialBar-bottom-counts').find('.socialBar-shares').each(function() {
//                 $(this).html(totalCount + ' <span class="label">Shares</span>');
//                 $(this).css({"display" : "inline-block"});
//                 if($(this).parent().find('.socialBar-clicks').is(':visible')) {
//                     $(this).parent().find('.socialBar-divide').css({"display" : "inline-block"});
//                 }
//             });
//         }else{
//             //$(".socialBar-shares").html(totalCount + ' <span class="label">Shares</span>');
//             //$(".socialBar-divide").css({"display" : "none"});
//             //$(".socialBar-shares").css({"display" : "none"});
//             c.parent().find(".socialBar-shares").each(function() {
//                 $(this).html(totalCount + ' <span class="label">Shares</span>');
//                 $(this).css({"display" : "none"});
//                 $(this).parent().find('.socialBar-divide').css({"display" : "none"});
//             });
//         }
//     }
// }


//function to format numeric results - 12,654 == 12.6k etc,...
// window.nFormatter = function(num) {
//     if (num >= 1000000000) {
//         return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
//     }
//     if (num >= 1000000) {
//         return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
//     }
//     if (num >= 1000) {
//         return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
//     }
//     return num;
// }

//GET SOCIAL NETWORK SHARE COUNTS
window.getFbShareCount = function(){
    var shareUrl = window.location.href;
    $.ajax({
        url: 'https://graph.facebook.com/?id='+shareUrl,
        success: function(data){
            $(data).each(function(i,k){
                //alert(k.shares);
                var fbShares = k.shares;
                if( fbShares == '' || fbShares == 'undefined' || fbShares == undefined ){
                    fbShares = 0;
                }else{
                    fbShares = fbShares;
                    $(".fb_icon .bubble").css({ "display" : "block" });
                }
                $(".fb_icon .bubble").html(fbShares);
            });
        }
    });
}

window.getTweetCount = function(){
    var shareUrl = window.location.href;
    $.ajax({
        url: 'https://urls.api.twitter.com/1/urls/count.json?url='+shareUrl,
        dataType: "jsonp",
        success: function (data) {
            $(data).each(function(i,k){
                //alert(k.shares);
                var twtCount = k.count;
                if( twtCount == '' ){
                    twtCount = 0;

                }else{
                    twtCount = twtCount;
                    $(".tweet_icon .bubble").css({ "display" : "block" });
                }
                $(".tweet_icon .bubble").html(twtCount);

            });
        }
    });
}

window.getLinkedCount = function(){
    var shareUrl = window.location.href;
    $.ajax({
        url: 'https://www.linkedin.com/countserv/count/share?url='+shareUrl+'&callback=myCallback&format=jsonp',
        dataType: "jsonp",
        jsonpCallback: "myCallback",
        success: function (data) {
            $(data).each(function(i,k){
                //alert(k.shares);
                var linkedCount = k.count;
                if( linkedCount == '' ){
                    linkedCount = 0;

                }else{
                    linkedCount = linkedCount;
                    $(".lnkdin_icon .bubble").css({ "display" : "block" });
                }
                $(".lnkdin_icon .bubble").html(linkedCount);
            });
        }
    });
}

//SET UP FACEBOOK COMMENTS/ADMINS ELEMENTS - MUST GO BEFORE EXECUTION OF FACEBOOK SDK
/*function load_fbcomments() {

  var comments_container = document.getElementById("fb-comments-container");


  if(comments_container != null ) {
    var div_fb_comments = document.createElement("div");
    div_fb_comments.setAttribute("class","fb-comments");
    div_fb_comments.setAttribute("data-href", window.location.hostname+window.location.pathname);
    div_fb_comments.setAttribute("data-numposts", "20");
    div_fb_comments.setAttribute("data-colorscheme", "light");
    div_fb_comments.setAttribute("data-width", "100%");
    comments_container.appendChild(div_fb_comments);
  }
//END SET UP FACEBOOK ELEMENTS
}
*/

window.load_fb_sdk = function() {

    window.fbAsyncInit = function() {
        // init the FB JS SDK
        FB.init({
            appId      : SITE_INFO['FB_app_id'],  // App ID from the app dashboard
            status     : true,                    // Check Facebook Login status
            xfbml      : true,                    // Look for social plugins on the page
            version    : 'v4.0',
        });
        // channelUrl : '//WWW.YOUR_DOMAIN.COM/channel.html', // Channel file for x-domain comms
        // Additional initialization code such as adding Event Listeners goes here
    };
  
    // Load the SDK asynchronously
    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/all.js";
        js.onload = function(){
            fbAsyncInit();
        };
        fjs.parentNode.insertBefore(js, fjs);
     }(document, 'script', 'facebook-jssdk'));
  
}









////////////////////////////////////////////////////////////////////////////////
// UTILITY FUNCTIONS ///////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

window.hasClass = function(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
}

window.isVisible = function(el) {
    return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );
}

window.isVisibleOnScreen = function(elm) {
    var rect = elm.getBoundingClientRect();
    var doc = document.documentElement;
    var viewHeight = Math.max(doc.clientHeight, window.innerHeight);

    // console log if true
    /*if(!(rect.bottom < 0 || rect.top >= viewHeight || (rect.height == 0 && rect.width == 0))) {
    console.log('-----------------------------------------');
    console.log(elm);
    console.log('rect.bottom: '+rect.bottom);
    console.log('rect.top: '+rect.top);
    console.log('topScroll: '+viewHeight);
    console.log('-----------------------------------------');
  }*/

    return !(rect.bottom < 0 || rect.top >= viewHeight || (rect.height == 0 && rect.width == 0));
}

window.firstVisibleElement = function(str) {

    var results = Array.prototype.slice.call(document.querySelectorAll(str))

        .filter(function (item,index) {

            if( isVisible(item) ) {
                return true;
            } else {
                return false;
            }
        });

    if(results && results.length) {
        return results[0];
    } else {
        return null;
    }
}

if( typeof readCookie === 'undefined' ){
    window.readCookie = function(name) {

        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
}

if( typeof createCookie === 'undefined' ){
    window.createCookie = function(name,value,days, expire_in_hours ) {

        if (days) {
            //allows us to set cookie expirations based on hours rather than days
            if(typeof expire_in_hours !== 'undefined' && expire_in_hours == true){
                var date = new Date();
                date.setTime(date.getTime()+(days*60*60*1000));
                var expires = "; expires="+date.toGMTString();
            }else{
                var date = new Date();
                date.setTime(date.getTime()+(days*24*60*60*1000));
                var expires = "; expires="+date.toGMTString();
            }
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/; domain=."+getDomain()+"";
    }
}

if( typeof eraseCookie === 'undefined' ){
    window.eraseCookie = function(name) {

        createCookie(name,"",-1);
    }
}

//handler to fire script from script
window.loadscript = function(script_url, target_id, callback, attr_obj)
{
    var elem = document.getElementById(target_id);

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = script_url;

    if(typeof attr_obj != 'undefined')
    {
        for(var k in attr_obj) {
            script[k] = attr_obj[k];
            script.attributes[k] = attr_obj[k];
            script.setAttribute(k, attr_obj[k]);
        }
    }

    if(callback != null) {
        script.onreadystatechange = callback;
        script.onload = callback;
    }
    elem.appendChild(script);
}

window.getDocHeight = function() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}

if( typeof getDomain === 'undefined' ){
    //used with createcookie function to match domain
    window.getDomain = function(){

        var path = window.location.host;
        if(path.substr(0,3)=='www'){
            var per=path.indexOf('.')
            per=per+1;
            path=path.substr(per);
        }
        return path;
    }
}

//gets querystring variable value
window.getQueryVariable = function(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
}



//*Global Click Tracking
// Track a click with ClickTracking.record_click(event, entry_id, atxt, site_module, section);
//
// */
function init_click_tracking(){
    window.ClickTracking = {
        site: SITE_INFO['name'],
        ajax: function(sURL) {
            //Takes sURL and makes a GET request.
            var oReq = new XMLHttpRequest();
            oReq.arguments = Array.prototype.slice.call(arguments, 2);
            oReq.onload = function(e) { console.log(oReq.responseText) };
            oReq.onerror = function(e) { console.log(oReq.responseText); };
            oReq.open("get", sURL, true);
            oReq.send(null);
        },
        record_click: function(event, entry_id, atxt, site_module, section, permanent, position, partner_title) {
            // Takes parameters and builds a call to click tracker service.
            event = event || window.event; //The click event, or a fallback value
            var href = '';

            // console.log("event target: "+event.target.nodeName);

            if(event.target.nodeName=="IMG"){ //incase we are linking images
                href = event.target.parentNode.href;
            }else{

                if(event.target.href.length > 2) {
                    href = event.target.href;
                } else {
                    href = event.target.parentNode.href;
                }
            }

            //Build the params to go to click tracking.
            var url = window.location.protocol+'//util.realclearpolitics.com/trackclicks/trackclick.php?';
            url += 'site='+this.site+'&';
            if(typeof(entry_id) != 'undefined') url += 'entry_id='+entry_id+'&';
            if(typeof(atxt) != 'undefined') url += 'atxt='+atxt+'&';
            if(typeof(site_module) != 'undefined') url += 'site_module='+site_module+'&';
            url += 'entry_url='+href+'&';
            if(typeof(section) != 'undefined') url += 'section='+section;
            if(parseInt(permanent) == 1) url += '&perm='+'1'+'&position='+position+'&partner_title='+partner_title;

            try{
                var tclick = this.ajax(url);
                console.log(tclick);
            } catch(err) {
                console.log("Track failed: "+err.message);
            } finally {
                if(event.ctrlKey || event.metaKey) { //If right-click or control click
                    return true;
                } else {

                    var target = event.target.target;


                    if(typeof target !== "undefined" && target !== false && target == '_blank'){ 
                        window.open(href);
                    }else{

                        //CATCHALL FOR OLDER BROWSERS -- NEW BROWSERS WERE ABLE TO LEVERAGE LINK HREF COMMAND WITHOUT THE NEED OF BELOW REDIRECT
                        window.setTimeout('document.location = "' + href + '"', 100); //Go to hyperlink
                        return false;

                        //AUTOREFRESH FOR INTERSTITIAL OUTBOUND LINKS RUNNING OFF ADSUPPLY - AUTOREDIRECTS TO OUTBOUND LINK FROM INTERSTITIAL SCREEN AFTER X SECS
                        /*setTimeout(function(){
                            document.location = href; //Go to hyperlink
                            return false;
                    },10000); //delay is in milliseconds 

                        */
                    }

                }
            }
        }
    };
}

//**End Click Tracking**/











////////////////////////////////////////////////////////////////////////////////
// SCRIPT LOADING FUNCTIONS ////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/*

NAME: loadScriptsDynamicSync
INPUT: arr_of_scripts (array of objects)
RETURNS: -
SIDE EFFECT: writes script tags in order to trigger synchronous execution

By writing a script tag directly to the page we are able to trigger a dynamic
synchronous execution of a js file.

arr_of_scripts must be an array of objects that at least have a property of
'src' equal to some valid javascript url.

We also allow any additional attributes to be specified.

*/

window.loadScriptsDynamicSync = function(arr_of_scripts) {

    for(var i = 0; i < arr_of_scripts.length; i++) {

        var extra_attr = '';

        for(var key in arr_of_scripts[i]) {
            if(arr_of_scripts[i].hasOwnProperty(key)) {

                if(key != 'src') {

                    extra_attr += ' '+key+'="'+arr_of_scripts[i][key]+'" ';
                }
            }
        }

        document.write('\x3Cscript type="text/javascript" src="'+arr_of_scripts[i]['src']+'" '+extra_attr+'>\x3C/script>');
    }
}


////////////////////////////////////////////////////////////////////////////////
// EVOLOK FUNCTIONS ////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function evolok_init() {

    if(evolok_init_called === true) { return; }

    evolok_init_called = true;

    console.log("ADMIRAL evolok_init");

    // if ad free account it doesn't wait around to check for ad block since it doesn't matter for ad free accounts
    var ad_free = readCookie('evaf');
    // console.log("evolok init ad_free: ", ad_free, "warning widget: ", warning_widget);
    if( ad_free !== 'null' && ad_free !== null ){
        warning_widget.ad_block_ready_for_check = true;
        Utils.global_settings.realclear_ad_block_check = false;

    // if no ad free trigger ads right away but still let evolok check for ad block below
    }else if(SITE_INFO['name'] !== 'markets') {
        try{
            //
            
            evolok_do_ads = true;
            allow_ad_render = true;
            init_all_ads();
            
        }catch(err){
            console.log(err);
        }

    }

    var adblock_exists_check = null;

    //if main evo library is ready
    if(typeof window.EV !== 'undefined' && !evolok_init_finished && SITE_INFO['evolok_enabled'] !== false) {

        adblock_exists_check = window.setInterval(function(){

            if( warning_widget.ad_block_ready_for_check == true || warning_widget.ad_block_ready_for_check == "true" ){

                console.log('EVOLOK Console: USING ADBLOCK::: ' + Utils.global_settings.realclear_ad_block_check);
                clearInterval(adblock_exists_check);
                allow_ad_render = true;
                continue_ev_init(Utils.global_settings.realclear_ad_block_check);

            }else{
                console.log('EVOLOK Not ready to check adblock::: ' + warning_widget.ad_block_ready_for_check);
            }

        }, 100);

        //global param indicating libraries are ready
        evolok_init_finished = true;

    } else {
        console.log('ev undefined or init already called');
        init_all_ads();
    }
}

function continue_ev_init(adBlockEnabled){

    var evp = {};

    if(typeof window.ev_params !== 'undefined') {
        evp = window.ev_params;
    }

    console.log("inline evolok params:::: ", evp);

    var id_timestamp = Math.floor(Date.now() / 1000 / 60);

    var ev_article_id = id_timestamp;

    var wevp = {"articleId":ev_article_id,"site":SITE_INFO['name'],"adblock":adBlockEnabled};

    var all_params = Object.assign(wevp, evp);

    console.log("ALL evolok PARAMS:::: ", all_params);

    window.evolok_params = JSON.stringify(all_params);

    var ev_init_url = "//rcp.evolok.net/acd/api/3.0";
    var cookieDomain = "realclear"+SITE_INFO['name']+".com";

    if(Utils.get_query_param('evo_test') == 'true') {
        ev_init_url = "//rcp.uat.evolok.net/acd/api/3.0";
    }

    EV.Em.init({
        sidCookieDomain: document.domain,
        url: ev_init_url
    });

    EV.Em.authorize(window.evolok_params, evolok_metering_success, evolok_metering_error);
}


function evolok_metering_success (response) {
    console.log('evolok success response: ', response);

    if(response.result == 'ALLOW_ACCESS' &&
        response.loggedOut == false &&
        typeof response.ruleProperties !== 'undefined' &&
        response.ruleProperties.ADFREE == 'true') {

        evolok_block_ads = true;

        createCookie('evaf','1','365');

        // This means ads have shown, at least some inline ones that depend on cookie
        // So it's best to refresh
        // checks if we can read a cookie, means cookies are enabled
        // m.b. added 9.27 - typeof check for ad free sites - master loads after invchnl_rcmg.js file causing false positive
        if( ( typeof inline_ads_status !== 'undefined' && inline_ads_status == 'shown' ) && readCookie('evaf') ) {
            location.reload();
            return;
        }

        // We now know that ads will not be loaded, and there is no need for a refresh.
        // So we can display the tempshow notifications
        if(typeof Tempshow !== 'undefined') {

            var tempshow = new Tempshow;

            // 15 sec every time
            tempshow.create({
                msg: 'RCMG Ad-Free',
                seconds: 15
            });

            $('body').addClass('ad-free');

            if(readCookie('purchase_thanks_hp_modal') != '1') {

                // permanent just once
                tempshow.create({
                    msg: 'Thank you for your support!<br />Enjoy your ad-free experience.',
                    type: 'subscribe_thanks',
                    seconds: 20,
                    vertical: 'center',
                    horizontal: 'center',
                    width: '500px'
                });
                createCookie('purchase_thanks_hp_modal','1','365');
            }
        }
        return;

    } else {
        if(readCookie('user_access') != null ) {
            check_coupon_access();
        } else {

            eraseCookie('evaf');
            refresh_if_af_from_cookie();
            evolok_do_ads = true;
            init_all_ads();
        }
    }

    
    log_active_user();
    
    /*registers events for GA */
    if( typeof response.activeMeter != 'undefined' && typeof response.activeMeter.count != 'undefined' && response.activeMeter.count > 1 && response.userProperties.adblock == 'true'){
        AdblockModalEventTriggers().then(module => module.default());
    }
}

function check_coupon_access() {

    rcmg_api_call('get_coupon_data', {
        'coupon_data': readCookie('user_access')
    }, function (response) {
        var current_time = Math.floor(Date.now() / 1000);

        if (response.success && response.data && response.data.coupon_data.coupon_expiration_date > current_time) {
            
            evolok_metering_success({result: 'ALLOW_ACCESS', loggedOut: false, ruleProperties: {ADFREE: 'true'}, userProperties: {adblock: 'true'}, activeMeter: {count: 2}});

        } else {
            eraseCookie('user_access');
            eraseCookie('evaf');
            refresh_if_af_from_cookie();
            evolok_do_ads = true;
            init_all_ads();
        }
        
    });
    
}

function evolok_metering_error(response) {

    if(readCookie('user_access') != null ) {
        check_coupon_access();
    } else {
        console.log('evolok metering error', response);
        //console.log(response);
        
        eraseCookie('evaf');
        refresh_if_af_from_cookie();
    
        evolok_do_ads = true;
    
        init_all_ads();
    }

}

function init_all_ads(){

    console.log("ADMIRAL EVOLOK init_all_ads has INIT ads: ", HAS_INIT_ADS);

    // make sure this only runs once
    if( HAS_INIT_ADS === true){
        return;
    }

    HAS_INIT_ADS = true;

    // gpt ads are lazy loaded so this can run asap because it'll find anchors on its own
    
    AdsenseAds()
    .then(module => {
        window.loadAds = module.default;
        window.loadAds();
    });
    
    

    // ads may run before document is ready so place any document touching ads here
    $(document).ready(function(){
        
        loadGotChosen();

        //loadPrimisWidget();
        loadMGIDWidget();
        // distroscale_init();
        render_video_player();
        markets_investingchannel();
        load_insticator();
        loadInfinityAds();

        setTimeout(function(){
            fark_widgets_init();
            mgid_init();
        }, 250);
        if(typeof load_spot_recirculation == 'function') {load_spot_recirculation(); }
        //load loadLockerdome everywhere else except for science
        // if(typeof loadLockerdome == 'function') { loadLockerdome(); }
        spot_right_rail_init();

    });

}

function check_ios_app()
{
    // check if the user is using the ios app

    let userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent),
    firefox = /firefox/.test( userAgent ),
    opera = /opera/.test( userAgent ),
    chrome = /chrome/.test( userAgent ),
    ios = /iphone|ipad/.test( userAgent );

    if (ios) {
        if (!safari && !firefox && !opera && !chrome) {
            // ios app
            $('.RC-AD').hide();
            $('.ad-location-1').remove();

            window.all_ads_disabled = true;

            return true;
        }
    }

    return false;
}

$(window).scroll(function() {

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        $('[data-spotim-module=pitc]').hide();
        $('[data-spotim-module=pitc]').css('display', 'none');
    }
    //we check if the user has purchased the ad-free version
    if( readCookie('evaf') != null && parseInt(readCookie('evaf')) == 1 ) {
        $('[data-spotim-module=pitc]').hide();
        $('[data-spotim-module=pitc]').css('display', 'none');
    }
    var noAds = document.querySelector('[data-no-ads]');
    if(noAds){
        console.log('NO ADS IS ACTIVE');
        $('[data-spotim-module=pitc]').hide();
        $('[data-spotim-module=pitc]').css('display', 'none');
    }
});

function refresh_if_af_from_cookie() {

    if( ( typeof inline_ads_status !== 'undefined' && inline_ads_status == 'skipped' )) {

        location.reload();
    }
}

// The following functions are for checking if the user has purchased
// Done after filling in fn/ln/email form on subscription page
window.evolok_post_init_check = function() {

    EV.Em.authorize('{"site":"'+SITE_INFO['name']+'"}', evolok_post_init_metering_success, evolok_post_init_metering_error);
}

window.evolok_post_init_metering_success = function(response) {

    if(response.result == 'ALLOW_ACCESS' &&
        response.loggedOut == false &&
        typeof response.ruleProperties !== 'undefined' &&
        response.ruleProperties.ADFREE == 'true') {

        evolok_already_purchased();
    }
}

window.evolok_post_init_metering_error = function(response) {
    console.log('Error with post-init authorize call');
    //console.log(response);
}

window.evolok_already_purchased = function(){} // overwrite where needed as a callback

// flags to keep track one has started
var distroscale_master_init = false;
var jw_player_master_init = false;

function render_video_player(){

    // 8/5/2022 all day, disable
    var now_ts = Date.now()/1000;
    if(now_ts > 1659672000 && now_ts < 1659758400) { return; }

    console.log('COOL RENDER_VIDEO_PLAYER GETS CALLED');
    /**
     * Load edge ad if video player can't run right now
     * ( readCookie("distroscale_shown_new") || readCookie('dst_close_button_clicked') ) 
     * Distro is totally turned off right now so no need to check for that right now but will need to if it gets turned on in the future
     */
    // console.log("render_video_player", readCookie("jw_player_shown_new"), readCookie('jw_player_close_button_clicked'), readCookie("jw_player_shown_new") || readCookie('jw_player_close_button_clicked'));
    if( SITE_INFO['name'] == 'politics' 
        && $('body').hasClass('home')
        && (
            readCookie("jw_player_shown_new") !== null || readCookie('jw_player_close_button_clicked') !== null
            || readCookie("distroscale_shown_new") !== null || readCookie('dst_close_button_clicked') !== null
        )
        && Utils.get_query_param('force_jw') == null
        && Utils.get_query_param('force_dst') == null ){
        // we only show this ad when there are no other players on the page
        init_edge_ad();
        return;
    }

    // // if not part of allowed sites to do JW Player
    // // then just do distroscale by default
    // if( allowedSites.indexOf(SITE_INFO['name']) == -1 ){
    //     distroscale_init();
    //     return;
    // }

    // otherwise do 0/100 to switch between distro and JW player
    var rand = parseInt(Math.floor(Math.random() * 100) +1);

    if( Utils.get_query_param('force_dst') !== null ){
        rand = 100;
    }
    console.log(rand +'<-- COOL THIS IS THE RAND NUMBER');
    // console.log("VIDEO PLAYER RENDER VIDEO PLAYER RAND NUMBER", rand);
    
    if((rand <= 90 || Utils.get_query_param('force_jw') !== null) && Utils.get_query_param('force_dst') == null){
        if( Utils.get_query_param('force_jw') !== null ){
            console.log('COOL FORCED JW PLAYER');
            jwplayer_widget_init();
            return;
        }
        if(readCookie("show_dst_instead") !== null) {
            distroscale_init();
            console.log('COOL CALLING DST');
            return;
        } else {
            jwplayer_widget_init();
            console.log('COOL CALLING JW');
            return;
        }
        
    }else {
        distroscale_init();
        console.log('COOL CALLING DST');
        return;
    }

}

function init_edge_ad(){

    if(readCookie('evaf') !== null && parseInt(readCookie('evaf')) === 1) {
        // Ad free. Exit jw player.
        return;
    }

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads) {
            // Just skip and wait for next function call for a status change 
            return;
        }
        // Otherwise go ahead and do ads
    }

    // <script data-cfasync="false" language="javascript" async src="//udmserve.net/udm/img.fetch?sid=16605;tid=1;dt=6;"></script>
    var UNDERDOGMEDIA = document.createElement('script');
    UNDERDOGMEDIA.type = 'text/javascript'; 
    UNDERDOGMEDIA.async = true;
    UNDERDOGMEDIA.src = (document.location.protocol == "https:" ? "https:" : "http:") + '//udmserve.net/udm/img.fetch?sid=16605;tid=1;dt=6;';
    UNDERDOGMEDIA.setAttribute("data-cfasync", "false");
    UNDERDOGMEDIA.setAttribute("language", "javascript");
    var first_script = document.getElementsByTagName('script')[0];
    first_script.parentNode.insertBefore(UNDERDOGMEDIA, first_script);

    send_ga_event({
        'ge_action' : 'Edge/Underdog',
        'ge_category' : 'Homepage',
        'ge_label' : 'Politics',
        'ge_noninteraction' : true,
    });
}

function jwplayer_widget_init(){

    // console.log('jwplayer_widget_init called');

    // if( typeof start_jw_player_library == 'undefined' ){
    //     console.log("Unable to start jwplayer library, jwplayer_widget_init not found");
    //     return;
    // }

    // if set force it will ignore this section
    if( Utils.get_query_param('force_jw') == null ){

        if(readCookie('evaf') !== null && parseInt(readCookie('evaf')) === 1) {
            // Ad free. Exit jw player.
            return;
        }
    
        if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
            return;
        }

        if(evolok_init_finished) {

            if(!evolok_do_ads) {
                // Just skip and wait for next function call for a status change 
                return;
            }
            // Otherwise go ahead and do ads
        }

        if( readCookie("jw_player_shown_new") || readCookie('jw_player_close_button_clicked') || jw_player_master_init == true ){
            return;
        }

    }
    
    jw_player_master_init = true;
    
    HomepageJwPlayer()
    .then(module => {
        module.default();
    });
}

////////////////////////////////////////////////////////////////////////////////
// DISTROSCALE FUNCTIONS ///////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

//DISTROSCALE VIDEO WIDGET
function distroscale_init(){

    console.log('distroscale_init called');

    if( Utils.get_query_param('force_dst') == null ){
        console.log('inside if line 3343');
        if(evolok_init_finished) {

            if(!evolok_do_ads && (readCookie('evaf') != null && parseInt(readCookie('evaf')) == 1) ) {
                // Just skip and wait for next function call for a status change 
                console.log('ad_free exit distro');
                return;
            }
            // Otherwise go ahead and do ads
        }

        // if distro already shown
        if( readCookie("distroscale_shown_new") || readCookie('dst_close_button_clicked') ){

            //TESTING OVERRIDE
            /*if(typeof Utils.get_query_param == 'function'){
                if( Utils.get_query_param('ds_z') == null && Utils.get_query_param('ds_t') == null ){
                    console.log('already shown exit distro');
                    return;
                }
            }*/

            // console.log('already shown exit distro');
            // return;

        }

        if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
            return;
        }
    }

    distroscale_master_init = true;
    console.log('COOL MASTER INIT VALUE:' + distroscale_master_init);
    var allowedSites = [
        "science",
        "policy",
        "politics",
        "defense",
    ];

    if( $.inArray(SITE_INFO['name'], allowedSites) > -1 ){

        HomepageDistroscale()
        .then(module => {
            module.default();
        });
    }


}













////////////////////////////////////////////////////////////////////////////////
// SPOT.IM FUNCTIONS ///////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

//SPOT.IM DOC READY -- NEEDED TO CALL OUT EACH TEMPLATE AND APPEND SPOT.IM WIDGET TO RIGHT RAIL WHEN ELEMENTS ARE ALL LOADED - ONLY RCP!!!
window.spot_right_rail_init = function() {

    // 8/5/2022 all day, disable
    var now_ts = Date.now()/1000;
    if(now_ts > 1659672000 && now_ts < 1659758400) { return; }

    if(typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if(evolok_init_finished) { // Evolok is initiated

        if(!evolok_do_ads) {
            console.log('skip and wait for next function call');
            // Just skip and wait for next function call for a status change
            return;
        }
        console.log('go ahead and do spot right rail');
        // Otherwise go ahead and do ads
    }

    var allowedSites = [
        "defense",
        "markets",
        "world",
        "science",
        "history",
        "policy",
        "religion",
        "energy",
        "investigations",
        "health",
        "eduction",
        "books",
        "politics"
    ];

    if( $.inArray(SITE_INFO['name'], allowedSites) > -1 ){

        SpotRightRail()
        .then(module => {
            module.default();
        });

    }
}


////////////////////////////////////////////////////////////////////////////////
// STORY STREAM FUNCTIONS //////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

/**TEMPORARY FIX
 Allows us to change the stream page for sponsors and custom ads on page.
 10.03.16 A.A. - Added time outs for each section of this to make sure that the content is updated either on first try or on second try from timeouts because of a race between this and story-stream.js to update the header of the story streams page.
 **/
function init_story_stream_related() {

    if( SITE_PAGE == 'story-stream' && SITE_INFO['story_stream_related'] == true ) {
        StoryStreamSponsored()
        .then(module => {
            module.default();
        });
    }
}



////////////////////////////////////////////////////////////////////////////////
// HOMEPAGE FUNCTIONS //////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function viewSwitcher(){

    if( $('body.home').length > 0 ){

        HomepageLayoutSwitcher()
        .then(module => {
            module.default();
        });

    }
}











////////////////////////////////////////////////////////////////////////////////
// CONGRESSIONAL BILL TRACKER FUNCTIONS ////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function cbtSearch(){
    $( "#cbt-searchBox" ).keypress(function(e) {
        //e.preventDefault();
        if(e.which == 13) {
            searchText = ($(this).val());
            window.location = window.location.protocol+'//dyn.realclearpolitics.com/congressional_bill_tracker/search/' + searchText + '';
            $(this).val('');
        }
    });
}

function toggleCBTsearch(){
    $( ".cbt-widget .filter" ).click(function(){
        $( ".cbt-widget .search #cbt-searchBox" ).toggle();
        $( ".cbt-widget .search #form_state_select" ).toggle();
        $( ".cbt-widget .search .select" ).toggle();
    });
}











////////////////////////////////////////////////////////////////////////////////
// COMMENTS FUNCTIONS //////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function showComments(){
    $('.comments-count .show').click(function(){
        $(this).parent().parent().find("#comments-container").show();
        $(".comments-count .show").hide();
        $(".comments-count .hide").show();

        clearInterval(rcp_page_refresh_interval); //CLEARS THE REFRESH INTERVAL SET ON rcp.js
    });
}

function hideComments(){
    $('.comments-count .hide').click(function(){
        $(this).parent().parent().find("#comments-container").hide();
        $(".comments-count .hide").hide();
        $(".comments-count .show").show();
    });
}

function showHideComments(){
    $('.comments-wrapper .comments-label').click(function(){
        $(this).parent().parent().find("#comments-container").toggle();
        $(".comments-count .hide").toggle();
        $(".comments-count .show").toggle();

        clearInterval(rcp_page_refresh_interval); //CLEARS THE REFRESH INTERVAL SET ON rcp.js
    });
}











////////////////////////////////////////////////////////////////////////////////
// HP RECENTS FUNCTIONS ////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function recentItemsSlider()
{
    var $container = $('.hp-recents-container');
    if($container.length > 0) {
        RecentScrollerSlider()
        .then(module => {
            module.default();
        });
    }
}

var resize_timeout_recents;

window.throttle_resize_recents = function()
{
    window.clearTimeout(resize_timeout_recents);
    resize_timeout_recents = setTimeout(window_resize_recents, 70);
}

window.window_resize_recents = function()
{
    //DESTROY FLEXSLIDER IF EXISTS
    var flexslider = $('.hp-recents-container #entries').data('flexslider');
    if(flexslider != undefined)
    {
        flexslider.destroy();
        var grid_size = get_grid_size_recents();
        $('.hp-recents-container #entries').flexslider({
            animation: "slide",
            slideshowSpeed: 5000,
            controlNav: false,
            itemWidth: 200,
            minItems: grid_size,
            maxItems: grid_size
        });
    }
}

window.get_grid_size_recents = function()
{
    var w_width = window.innerWidth;
    if(w_width < 480) {
        return 1;
    } else if(w_width < 760) {
        return 2;
    } else if(w_width < 860) {
        return 3;
    } else if(w_width < 1080) {
        return 4;
    } else {
        return 5;
    }
}

////////////////////////////////////////////////////////////////////////////
/////////////////////ADMIRAL INIT CCPA///////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

var admiral_gdpr_modal_active = false;

window.admiral_init = function(){

    $(document).ready(function(){
        $('.ccpaOptOut').click(function(){
            if(window.admiral){
                window.admiral('show', 'ccpa.main');
            }
        })
    })

    window.admiral('after', 'ccpa.loaded', function(opts) {
        if(opts.applies) {
            document.querySelector('.ccpaOptOut').style.display = 'inline-block';
            $('.ccpaOptOut').show();
        }
        if(opts.optedOut){

            var on_ccpa_optOut = {
                'ge_action' : 'CCPA Opted-Out View',
                'ge_category' : 'Consent',
                'ge_label' : 'Page: ' + $('body').attr('class'),
                'ge_index' : null,
                'ge_noninteraction' : true
            };

            send_notifier_event(on_ccpa_optOut);

        }
    });

    window.admiral('after', 'cmp.loaded', function(opts) {
        console.log("ADMIRAL GDPR MODAL LOADED", opts);

        if(opts.euVisitor === true && opts.consentKnown === false && opts.tcData.gdprApplies === true ){
            admiral_gdpr_modal_active = true;
        }
        
    });
}










////////////////////////////////////////////////////////////////////////////////
// OTHER FUNCTIONS /////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////

function init_menus_listeners()
{
    MenuTriggers()
    .then(module => {
        module.default();
    });
}

function displayStaff(){
    $('.menu .title').click(function(){
        var team = $( this ).parent().find(".author-wrapper");
        $( team ).toggle();
        $( this ).parent().toggleClass( "active" );
    });
}

window.postScroller = function(){
    var scrollerWidth = 0;
    //get width - per post item
    var postWidth = $( ".scroller .post" ).outerWidth();

    var postLimit = 6;
    var totalPosts = '';

    $( ".scroller .post" ).each(function(index) {
        scrollerWidth += parseInt($(this).outerWidth(), 10);
        totalPosts = index+1;
    });

    $( ".scroller" ).css({ "width" : scrollerWidth });

    $('.scroller-wrapper .right').click(function() {
        //alert(postWidth);

        postLimit += 1;
        if( postLimit != totalPosts ){
            $('.scroller').animate({left: '-=' + postWidth + 'px'}, 'fast');
        }

    });

    $('.scroller-wrapper .left').click(function() {
        //alert(postWidth);

        postLimit -= 1;
        if( postLimit > 6 ){
            $('.scroller').animate({left: '+=' + postWidth + 'px'}, 'fast');
        }

    });

}

function dateMenu(){
    $( ".date-menu" ).click(function(){
        $( ".date-menu .menu-marker" ).toggle();
        $( ".date-menu .menu" ).toggle();

        dateMenuVisible = true;

    });

}

function customSelectBox(){
    // Iterate over each select element
    $('#form_state_select').each(function () {

        // Cache the number of options
        var $this = $(this),
            numberOfOptions = $(this).children('option').length;

        // Hides the select element
        $this.addClass('s-hidden');

        // Wrap the select element in a div
        $this.wrap('<div class="select"></div>');

        // Insert a styled div to sit over the top of the hidden select element
        $this.after('<div class="styledSelect"></div>');

        // Cache the styled div
        var $styledSelect = $this.next('div.styledSelect');

        // Show the first select option in the styled div
        $styledSelect.text($this.children('option').eq(0).text());

        // Insert an unordered list after the styled div and also cache the list
        var $list = $('<ul />', {
            'class': 'options'
        }).insertAfter($styledSelect);

        // Insert a list item into the unordered list for each select option
        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        // Cache the list items
        var $listItems = $list.children('li');

        // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.styledSelect.active').each(function () {
                $(this).removeClass('active').next('ul.options').hide();
            });
            $(this).toggleClass('active').next('ul.options').toggle();
        });

        // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
        // Updates the select element to have the value of the equivalent option
        $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();
            /* alert($this.val());*/ //Uncomment this for demonstration!
            window.location = window.location.protocol+'//dyn.realclearpolitics.com/congressional_bill_tracker/state/' + $this.val() + '';
        });

        // Hides the unordered list when clicking outside of it
        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

    });
}

window.progressBar = function(){
    var getMax = function(){
        return $(document).height() - $(window).height();
    }

    var getValue = function(){
        return $(window).scrollTop();
    }

    //alert( 'getMax: ' + getMax() + ' -- ' + 'getVal: ' + getValue() );    

    if ('max' in document.createElement('progress')) {
        // Browser supports progress element
        var progressBar = $('progress');

        var top = $('#progress-bar').offset().top;




        // Set the Max attr for the first time
        progressBar.attr({ max: getMax() });

        $(document).on('scroll', function(){
            // On scroll only Value attr needs to be calculated
            progressBar.attr({ value: getValue() });

            var y = $(this).scrollTop();

            if( y > top ){
                // $('#progress-bar').addClass('fixed');
                $('.progress-bar').addClass('fixed');
                $(".progress-bar").css({ "position" : "fixed" });
            }else{
                //$('#progress-bar').removeClass('fixed');
                //$('.progress-bar').addClass('fixed');
            }

        });

        $(window).resize(function(){
            // On resize, both Max/Value attr needs to be calculated
            progressBar.attr({ max: getMax(), value: getValue() });
        });

    } else { //no browser support => older browsers and < IE10

        var progressBar = $('.progress-bar'),
            max = getMax(),
            value, width;

        var getWidth = function() {
            // Calculate width in percentage
            value = getValue();

            width = (value/max) * 100;
            width = width + '%';
            return width;
        }

        var setWidth = function(){
            progressBar.css({ width: getWidth() });
        }

        $(document).on('scroll', setWidth);
        $(window).on('resize', function(){
            // Need to reset the Max attr
            max = getMax();
            setWidth();
        });

    }
}

function onResize(){ //viewport has resize

    //on viewport resize
    $(window).resize(function(){

        //certain inline styles are applied onScroll in specific viewport sizes so we clear them here
        $('#masthead-container').attr('style','');
    });

}

//show/hide masthead on scrolling down/up
function onScroll()
{
    MastHeadScroller()
    .then(module => {
        module.default();
    });
}

window.getScrollPercent = function() {
    var h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';
    return h[st]||b[st] / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}

window.shareSelected = function(){
    var savedText = null; // Variable to save the text

    function saveSelection() {
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                return sel.getRangeAt(0);
            }
        } else if (document.selection && document.selection.createRange) {
            return document.selection.createRange();
        }
        return null;
    }

    function restoreSelection(range) {
        if (range) {
            if (window.getSelection) {
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (ddocument.selection && range.select) {
                range.select();
            }
        }
    }

    var btnWrap = document.getElementById('share-button'),
        btnShare = btnWrap.children[0];

    document.onmouseup = function(e) {

        savedText = saveSelection(); // Save selection on mouse-up

        //alert(savedText);

        setTimeout(function() {

            var isEmpty = savedText.toString().length === 0; // Check selection text length

            // set sharing button position
            //if( savedText.toString().length > 45 ){
            btnWrap.style.top = (isEmpty ? -9999 : e.pageY) + 'px';
            btnWrap.style.left = (isEmpty ? -9999 : e.pageX) + 'px';
            //}

        }, 10);

    };

    btnShare.onmousedown = function(e) {

        if (!savedText) return;

        //window.open('http://firefox.com/');
        window.open('https://twitter.com/intent/tweet?text=' + savedText, 'shareWindow', 'width=300,height=150,top=50,left=50'); // Insert the selected text into sharing URL
        restoreSelection(savedText); // select back the old selected text

        // hide if we are done
        setTimeout(function() {
            btnWrap.style.top = '-9999px';
            btnWrap.style.left = '-9999px';
        }, 1000);

        return false;

    };
}

function showMobileSearch (){
    $( ".site-search-mobile" ).click(function(){
        $( ".site-search.mobile" ).toggle();
        $( ".site-search-mobile" ).hide();
    });
}

window.goToByScroll = function(id){

    id = id || '';

    // Reove "link" from the ID
    id = id.replace("link", "");

    var offset;
    var navPointer;
    function getNav(){
        navPointer = $("#masthead-container").attr("class");

        if( navPointer === "nav-down" ){ //scrolling down
            if( id === "top" ){
                offset = 30;
            }else{
                offset = 50;
            }
        }else if( navPointer === "nav-up" ){
            if( id === "top" ){
                offset = 174;
            }else{
                offset = 104;
            }
        }else{
            offset = 0;
        }
    }
    //the use of timeout gets more accurate value of offset to use - allows scrolling to wind down before calculating
    setTimeout(getNav(), 4000);
    //set offset to control scroll stop point - home page only
    if( $("body.home").length > 0 ){
        // Scroll
        $('html,body').animate({ scrollTop: $("#"+id).offset().top-offset}, 'slow');
    }else{
        // Scroll
        $('html,body').animate({scrollTop: $("#"+id).offset().top}, 'slow');
    }

}

//SITE SEARCH
function siteSearch(){

    var searchText = null;

    if( $('body.home').length > 0 ){
        $( ".home-search #searchBox" ).keypress(function(e) {
            
            if(e.which == 13) {
                e.stopPropagation();
                e.preventDefault();
                searchText = ($(this).val());
                if(searchText == ''){
                    return;
                }
                searchText = searchText.replace(" ", "+");
                window.location = SITE_INFO['global_site_url']+'/search/?q=' + searchText + '';
                $(this).val('');
                return false;
            }
        });

    }else{

        $( "#searchBox" ).keypress(function(e) {
            
            if(e.which == 13) {
                e.stopPropagation();
                e.preventDefault();
                searchText = ($(this).val());
                if(searchText == ''){
                    return;
                }
                searchText = searchText.replace(" ", "+");
                window.location = SITE_INFO['global_site_url']+'/search/?q=' + searchText + '';
                $(this).val('');
                return false;
            }
        });
    }
}

window.convertImgUrl = function(url, target) {
    //Changes image url to an alternate resolution image
    var a = document.createElement('a');
    //If 'target' argument has no value or is zero, the new url will not have _N_ at the end (where N is a number).
    var new_res = typeof target === 'undefined' || target == 0 ? '' : '_'+target+'_';
    a.href = url;
    if(a.pathname.match(/\/(\d+)_([12345])_.(jpg|png|gif)/g)) {
        url = window.location.protocol+'//' + a.hostname + a.pathname.replace(/_[12345]_/g, new_res);
    }
    a.remove();
    return url;
}

window.upgradeImagesByDisplaySize = function() {
    var images = document.getElementsByTagName('img');
    for(var i=0; i<images.length; i++) {
        var alt_src = images[i].attributes['data-src'] || false;
        if(alt_src && window.matchMedia('screen and (min-width:400px)').matches) {
            //If there is an alternate (larger) image,
            //  and alt is different from the original src
            //  and the screen is >= 400px
            images[i].src = alt_src.value;
        }
    }
}






//RCP GOOGLE SURVEY BEACON POST-MESSAGE
if (window.addEventListener) {
    window.addEventListener("message", onMessage, false);
}
else if (window.attachEvent) {
    window.attachEvent("onmessage", onMessage, false);
}

function onMessage(event) {

    // Check sender origin to be trusted
    //comment out when testing from DFP
    if (event.origin !== "https://tpc.googlesyndication.com") return;

    var data = event.data;

    if (typeof(window[data.func]) == "function") {
        window[data.func].call(null, data.message,event.origin);
    }

}

// Function to be called from iframe
window.trackGoogleExposedSegment = function(message,origin) {


    //impression hit notice
    var data = {
        'ge_category' : 'RCP_Survey_Tracking_Beacon_1019',
        'ge_action' : 'Hit',
        'ge_label' : '1'
    };
    send_ga_event(data);



    beacon = readCookie("rcp_google_beacon_1019");

    if(beacon){ //EXISTS

        cookie_arr = beacon.split("|");
        user_id = cookie_arr[0];
        user_seen_ad = cookie_arr[1];
        num_exposures = cookie_arr[3]; //number of ad views

        if(user_seen_ad != '2'){ //known user, Flag as exposed

            //array -> user_id|status|timestamp|numexposures
            createCookie("rcp_google_beacon_1019",user_id+"|2|"+Date.now()+"|1",365); //resets cookie to exposed status

            var data = {
                'ge_category' : 'RCP_Survey_Tracking_Beacon_1019',
                'ge_action' : 'Hit',
                'ge_label' : '2'
            };

            send_ga_event(data); 

        }else if(user_seen_ad=='2'){

            if(typeof(num_exposures) != 'undefined'){ //make sure we have a num
                num_exposures = parseInt(num_exposures) + 1;

                //array -> user_id|status|timestamp|numexposures
                createCookie("rcp_google_beacon_1019",user_id+"|2|"+Date.now()+"|"+num_exposures,365); //resets cookie to exposed status

                var data = {
                    'ge_category' : 'RCP_Survey_Tracking_Beacon_1019',
                    'ge_action' : 'Hit',
                    'ge_label' : '3'
                };

                send_ga_event(data);

            }


        }

    }

}


/**
 * Triggers a customizable modal
 * @param  object userOpts object to override the default settings
 * @return object returns the object used to make the modal and interact with it
 */
window.rcTriggerModal = function(userOpts){

    userOpts = userOpts || {};

    var container_selector = '#promo-modal-container';

    var opts = {
        heading: 'Promo Notification',
        body_content:
            '<h3>This is a attention grabbing heading.</h3>'+
            '<p>Paragraph content here.</p>'+
            '<p>More content <button type="button" >button</button></p>',
        footer_btns: '',
        custom_id: 'customizable-as-you-see-fit',
        container_selector: container_selector,
        close_modal: function(){

            $(this.container_selector).hide();

            if( this.on_close !== null ){
                this.on_close();
            }
        },
        /**
         * On close hook
         */
        on_close: null,
    };

    $.extend(opts, userOpts);

    var container = '<div id="promo-modal-container" class="promo-modal-body-container"></div>';

    if( !document.getElementById('promo-modal-container') ){
        $('body').append(container);
    }

    var coreTemplate =
        '<div id="'+opts.custom_id+'" class="promo-modal-wrapper">'+
            '<div class="promo-modal-content">'+
                '<div class="promo-modal-head">'+
                    opts.heading+
                    '<div class="close-promo-modal"></div>'+
                '</div>'+
                '<div class="promo-modal-body">'+
                    opts.body_content+
                '</div>'+
                '<div class="promo-modal-footer">'+
                    opts.footer_btns+
                '</div>'+
            '</div>'+
        '</div>';

    $(container_selector).html(coreTemplate);

    $(container_selector).show();

    $(container_selector).on('click', '.close-promo-modal', function(){

        opts.close_modal();
    });

    return opts;
}

window.insert_tracking_admiral = function()
{
    if(SITE_INFO.admiral_id !== ''){
        var admiral_id = SITE_INFO.admiral_id;
        $script = '<script type="text/javascript">!(function(o,n,t){t=o.createElement(n),o=o.getElementsByTagName(n)[0],t.async=1,t.src="https://steadfastsound.com/v2/0/'+ admiral_id +'",o.parentNode.insertBefore(t,o)})(document,"script"),(function(o,n){o[n]=o[n]||function(){(o[n].q=o[n].q||[]).push(arguments)}})(window,"admiral");!(function(n,e,r,t){function o(){if((function o(t){try{return(t=localStorage.getItem("v4ac1eiZr0"))&&0<t.split(",")[4]}catch(n){}return!1})()){var t=n[e].pubads();typeof t.setTargeting===r&&t.setTargeting("admiral-engaged","true")}}(t=n[e]=n[e]||{}).cmd=t.cmd||[],typeof t.pubads===r?o():typeof t.cmd.unshift===r?t.cmd.unshift(o):t.cmd.push(o)})(window,"googletag","function");;;;;</script>';

        $($script).appendTo('head');
    }else{
        console.log('was not able to append admiral to head');
    }

}

/*Loads Insticator widget on Science
* Locations: Home, Articles index, article, Video
* */
function load_insticator(){

    // Used to prevent breaking on IE
    if(!window.IntersectionObserver){
        return;
    }

    if(evolok_init_finished) {

        if(!evolok_do_ads && (readCookie('evaf') != null && parseInt(readCookie('evaf')) == 1) ) {
            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }

    if( (siteName == 'science' ) &&
        ( $('body').hasClass('home') || $('body').hasClass('article') || $('body').hasClass('video') ) ) {

        if($('#insticator-ad-wrapper').length == 0){
            return;
        }

        Insticator()
        .then(module => {
            module.default();
        });

    }
}

$(document).ready(function(){
    notify_unconfirmed_subscription_users();

    if(readCookie('evaf') != null) {
        $('.ad-location-1').remove();
        console.log('removing ad-location-1');
    }
});

/*Notifies unconfirmed subscriber */
function notify_unconfirmed_subscription_users(){
    if(readCookie('unconfirmed_user')){

        if(readCookie('unconfirmed_user_notified')){
            console.log('we have already notified user');
        }else{
            //check if he has already confirm
            var rcmg_purchase_token = readCookie('rcmg_purchase_token');
            var data = {
                'site' : siteName,
                'rcmg_purchase_token' : rcmg_purchase_token,
            };

            rcmg_api_call('verify_unconfirmed_subscription', data, function(response) {

                if(response.success){

                    if(response.data.user_info.user_status == 1){ // user has already confirm no need to show modal remove cookie

                        deleteCookie('unconfirmed_user');
                        deleteCookie('unconfirmed_user_notified');
                        return;

                    }else{

                        //show modal
                        if(typeof Tempshow !== 'undefined' ) {

                            var tempshow = new Tempshow;

                            tempshow.create({
                                msg: `<p>
                                We noticed you purchased a subscription at some point but have not yet activated the account. Please confirm the email address used to purchase. This will allow you to enjoy an ad-free experience. <br /> <a href="javascript:void(0)" class="resend-confirmation-email">Resend Confirmation Email</a>
                                <div id="passform">
                                    <hr>
                                    <div class="pass-submitted">
                                        <p>Your password has been added to your account.</p>
                                    </div>
                                    <div class="pass-error">
                                        <p>There was an error adding the password to your account.<br>Please try again later or contact us <a href="https://${document.domain}/contact.html">here.</a></p>
                                    </div>
                                    <div class="no-pass">
                                        <p>Your account doesn't have a password. You can create a password below.</p>
                                    </div>
                                    <div id="enter_password">
                                        <input type="password" name="password" class="password" placeholder="Password" required>
                                        <input type="password" name="confirm_password" class="confirm_password" placeholder="Confirm Password" required>
                                        <span class="notice">Passwords Don't Match</span>
                                        <button disabled id="submit_button">Submit</button>
                                    </div>
                                    <div class="pass-entry">
                                        <div class="loading"></div>
                                    </div>
                                </div>
                                </p>`,
                                type: 'unconfirmed_notif',
                                seconds: 200,
                                vertical: 'center',
                                horizontal: 'center',
                                width: '500px'
                            });

                        }

                        //hide the password form if the user doesn't have a password
                        if(readCookie('user_no_pass') == 0){
                            $('#passform').hide();
                        } else {
                            $('.pass-submitted').hide();
                            $('.pass-error').hide();
                            $('#enter_password .notice').hide();

                            function validatePassword(){
                                var password = document.querySelector('#enter_password .password');
                                var confirm_password = document.querySelector('#enter_password .confirm_password');
                        
                                console.log("validating password");
                                if(password.value != confirm_password.value) {
                                    document.querySelector('#submit_button').disabled = true;
                                    $('#enter_password .notice').show();
                                } else {
                                    document.querySelector('#submit_button').disabled = false;
                                    $('#enter_password .notice').hide();
                                }
                            }

                            $('#enter_password .password').on('change', function() {
                                validatePassword();
                            });
                        
                            $('#enter_password .confirm_password').on('keyup', function() {
                                validatePassword();
                            })

                            $('#enter_password #submit_button').on('click',function() {
                                $('.pass-entry .loading').show();
                                $('#enter_password').hide();
                                $('.no-pass').hide();
                                
                        
                                rcmg_api_call('purchase_password', {
                                    password           : $('#enter_password .password').val(),
                                    confirm_password   : $('#enter_password .confirm_password').val(),
                                    purchase_token : readCookie('rcmg_purchase_token')
                                }, (response) => {
                                    if(!response.success) {
                                        $('.pass-error').text(response.messages[0].message);
                                        $('.pass-error').show();
                                        $('#enter_password').show();
                                        $('#enter_password .password').val("")
                                        $('#enter_password .confirm_password').val("")
                                        $('.no-pass').hide();
                                        $('.pass-entry .loading').hide();

                                        document.querySelector('#submit_button').disabled = true;
                                    } else {
                                        $('.pass-submitted').show();
                                        $('.no-pass').hide();
                                        $('.pass-entry .loading').hide();
                                        $('.pass-error').hide();

                                        // delete the no pass cookie
                                        deleteCookie('user_no_pass');
                                    }
                                });
                            });
                        }

                        //api click envent and logic for resending email
                        $(document).on('click', '.resend-confirmation-email', function(e){
                            e.preventDefault();

                            if( $('.resend-confirmation-email').find('div.loading').length == 1 ){
                                //prevents users from clicking multiple times amd making multiple request
                                return;
                            }

                            $('.resend-confirmation-email').html('<div class="loading" ><img alt="loading" style="height:20px" src="/asset/img/ajax-grey-sm.gif" /></div>');

                            //event handler for resend-confirmation-email
                            var rcmg_purchase_token = readCookie('rcmg_purchase_token');



                            if(rcmg_purchase_token){
                                var data = {
                                    'site' : siteName,
                                    'rcmg_purchase_token' : rcmg_purchase_token,
                                };

                                rcmg_api_call('resend_confirmation_email_to_unconfirmed_subscriber', data, function(response){

                                    if(response.success){

                                        $('.type_unconfirmed_notif .msg p').text('We have successfully sent the email confirmation. Please check your inbox.').addClass('success');

                                    }

                                });
                            }

                            //sending an google event
                            var data = {
                                'ge_action' : 'overlay shown',
                                'ge_category' : 'notices',
                                'ge_label' : 'Unconfirmed Subscription Popup',
                                'ge_noninteraction' : true
                            };

                            send_ga_event(data);

                        });//end of document.on.click

                        createCookie('unconfirmed_user_notified', true, 1);

                    }
                }
            });

        }
    }

}


function log_active_user(){

  if( typeof getCookie == 'function' ){

    if(!getCookie('daily_logged_in') && is_member_logged_in() == true ){
        //cookie has already expired ping util


        var data = {
            'is_ad_free' : parseInt(getCookie('evaf')),
            'rcmg_guid' : getCookie('rcmg_guid'),
            'site' : siteName
        };

        rcmg_api_call('daily_active_user', data , function(resp){

            if(resp.success){
                createDailyCookie('daily_logged_in', Date.now(), '/');
                console.log('daily user logged successfully');
            }

        } );

    }
  }else{
    return;
  }

}

window.createDailyCookie = function(name, value, path){
    var expires = "";
    var date = new Date();
    var midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    expires = "; expires=" + midnight.toGMTString();

    if (!path) {
        path = "/";
    }
    document.cookie = name + "=" + value + expires + "; path=" + path;
}

function mgid_init(){
    // We make a query selector to the data-no-ads class
    var noAds = document.querySelector('[data-no-ads]');
    //If the data target exists, we return
    if(noAds){
        $('.mixi_unit').remove();
        $('.mixi_unit').css('display', 'none');
        $('.fark-header').remove();
        $('.fark-header').css('display', 'none');
        return;
    }
    if (typeof all_ads_disabled !== 'undefined' && all_ads_disabled === true) {
        return;
    }

    if (evolok_init_finished) {

        if (!evolok_do_ads) {
            // Just skip and wait for next function call for a status change
            return;
        }
        // Otherwise go ahead and do ads
    }

    /**
     * Setting set from the cms to hide inline post/article mgid ads on certain posts
     */
    if(typeof NO_INLINE_ADS !== 'undefined' && NO_INLINE_ADS == true){
        console.log("EXITING MGID EARLY AS NO INLIINE ADS ALLOWED", NO_INLINE_ADS);
        return;
    }

    //for education SITE_INFO['name'] because siteName is set after function gets called

    let sites = [
        'politics',
        'science',
        'world',
        'defense',
        'policy',
        'history',
        'religion',
        'energy',
        'education',
        'books',
        'health',
    ];

    if( sites.indexOf(siteName) > -1 ) {

        MgidUnits()
        .then(module => {
            module.default();
        });
    }
}

/*social media skd*/
var fb_sdk =document.createElement('script');
fb_sdk.type='text/javascript';
fb_sdk.async=true;
fb_sdk.crossOrigin = 'anonymous';
fb_sdk.nonce = 'LyDJj0Y2'
fb_sdk.src='https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v10.0';
var fb_h=document.getElementsByTagName('script')[0];
fb_h.parentNode.insertBefore(fb_sdk,fb_h);

//TWITTER JS SDK
!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src="https://platform.twitter.com/widgets.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","twitter-wjs");

export default main_init_master;